var map = {
	"./": [
		62685,
		9,
		62685
	],
	"./_lib/buildFormatLongFn": [
		30012,
		7,
		30012
	],
	"./_lib/buildFormatLongFn/": [
		30012,
		7,
		30012
	],
	"./_lib/buildFormatLongFn/index": [
		30012,
		7,
		30012
	],
	"./_lib/buildFormatLongFn/index.js": [
		30012,
		7,
		30012
	],
	"./_lib/buildLocalizeFn": [
		71055,
		7,
		71055
	],
	"./_lib/buildLocalizeFn/": [
		71055,
		7,
		71055
	],
	"./_lib/buildLocalizeFn/index": [
		71055,
		7,
		71055
	],
	"./_lib/buildLocalizeFn/index.js": [
		71055,
		7,
		71055
	],
	"./_lib/buildMatchFn": [
		69425,
		7,
		69425
	],
	"./_lib/buildMatchFn/": [
		69425,
		7,
		69425
	],
	"./_lib/buildMatchFn/index": [
		69425,
		7,
		69425
	],
	"./_lib/buildMatchFn/index.js": [
		69425,
		7,
		69425
	],
	"./_lib/buildMatchPatternFn": [
		54078,
		7,
		54078
	],
	"./_lib/buildMatchPatternFn/": [
		54078,
		7,
		54078
	],
	"./_lib/buildMatchPatternFn/index": [
		54078,
		7,
		54078
	],
	"./_lib/buildMatchPatternFn/index.js": [
		54078,
		7,
		54078
	],
	"./af": [
		39689,
		9,
		57926
	],
	"./af/": [
		39689,
		9,
		57926
	],
	"./af/_lib/formatDistance": [
		83943,
		7,
		83943
	],
	"./af/_lib/formatDistance/": [
		83943,
		7,
		83943
	],
	"./af/_lib/formatDistance/index": [
		83943,
		7,
		83943
	],
	"./af/_lib/formatDistance/index.js": [
		83943,
		7,
		83943
	],
	"./af/_lib/formatLong": [
		95319,
		7,
		95319
	],
	"./af/_lib/formatLong/": [
		95319,
		7,
		95319
	],
	"./af/_lib/formatLong/index": [
		95319,
		7,
		95319
	],
	"./af/_lib/formatLong/index.js": [
		95319,
		7,
		95319
	],
	"./af/_lib/formatRelative": [
		66212,
		7,
		66212
	],
	"./af/_lib/formatRelative/": [
		66212,
		7,
		66212
	],
	"./af/_lib/formatRelative/index": [
		66212,
		7,
		66212
	],
	"./af/_lib/formatRelative/index.js": [
		66212,
		7,
		66212
	],
	"./af/_lib/localize": [
		2750,
		7,
		2750
	],
	"./af/_lib/localize/": [
		2750,
		7,
		2750
	],
	"./af/_lib/localize/index": [
		2750,
		7,
		2750
	],
	"./af/_lib/localize/index.js": [
		2750,
		7,
		2750
	],
	"./af/_lib/match": [
		24734,
		7,
		24734
	],
	"./af/_lib/match/": [
		24734,
		7,
		24734
	],
	"./af/_lib/match/index": [
		24734,
		7,
		24734
	],
	"./af/_lib/match/index.js": [
		24734,
		7,
		24734
	],
	"./af/index": [
		35982,
		7,
		35982
	],
	"./af/index.d": [
		57926,
		9,
		57926
	],
	"./af/index.d.ts": [
		57926,
		9,
		57926
	],
	"./af/index.js": [
		35982,
		7,
		35982
	],
	"./af/index.js.flow": [
		38689,
		7,
		38689
	],
	"./af/package": [
		20138,
		3,
		20138
	],
	"./af/package.json": [
		20138,
		3,
		20138
	],
	"./ar": [
		2826,
		9,
		97053
	],
	"./ar-DZ": [
		32763,
		9,
		51168
	],
	"./ar-DZ/": [
		32763,
		9,
		51168
	],
	"./ar-DZ/_lib/formatDistance": [
		50467,
		7,
		50467
	],
	"./ar-DZ/_lib/formatDistance/": [
		50467,
		7,
		50467
	],
	"./ar-DZ/_lib/formatDistance/index": [
		50467,
		7,
		50467
	],
	"./ar-DZ/_lib/formatDistance/index.js": [
		50467,
		7,
		50467
	],
	"./ar-DZ/_lib/formatLong": [
		60172,
		7,
		61345
	],
	"./ar-DZ/_lib/formatLong/": [
		60172,
		7,
		61345
	],
	"./ar-DZ/_lib/formatLong/index": [
		60172,
		7,
		61345
	],
	"./ar-DZ/_lib/formatLong/index.js": [
		60172,
		7,
		61345
	],
	"./ar-DZ/_lib/formatRelative": [
		19647,
		7,
		19647
	],
	"./ar-DZ/_lib/formatRelative/": [
		19647,
		7,
		19647
	],
	"./ar-DZ/_lib/formatRelative/index": [
		19647,
		7,
		19647
	],
	"./ar-DZ/_lib/formatRelative/index.js": [
		19647,
		7,
		19647
	],
	"./ar-DZ/_lib/localize": [
		27147,
		7,
		27147
	],
	"./ar-DZ/_lib/localize/": [
		27147,
		7,
		27147
	],
	"./ar-DZ/_lib/localize/index": [
		27147,
		7,
		27147
	],
	"./ar-DZ/_lib/localize/index.js": [
		27147,
		7,
		27147
	],
	"./ar-DZ/_lib/match": [
		81845,
		7,
		81845
	],
	"./ar-DZ/_lib/match/": [
		81845,
		7,
		81845
	],
	"./ar-DZ/_lib/match/index": [
		81845,
		7,
		81845
	],
	"./ar-DZ/_lib/match/index.js": [
		81845,
		7,
		81845
	],
	"./ar-DZ/index": [
		66497,
		7,
		66497
	],
	"./ar-DZ/index.d": [
		51168,
		9,
		51168
	],
	"./ar-DZ/index.d.ts": [
		51168,
		9,
		51168
	],
	"./ar-DZ/index.js": [
		66497,
		7,
		66497
	],
	"./ar-DZ/index.js.flow": [
		93712,
		7,
		93712
	],
	"./ar-DZ/package": [
		26890,
		3,
		26890
	],
	"./ar-DZ/package.json": [
		26890,
		3,
		26890
	],
	"./ar-EG": [
		17805,
		9,
		54430
	],
	"./ar-EG/": [
		17805,
		9,
		54430
	],
	"./ar-EG/_lib/formatDistance": [
		14875,
		7,
		14875
	],
	"./ar-EG/_lib/formatDistance/": [
		14875,
		7,
		14875
	],
	"./ar-EG/_lib/formatDistance/index": [
		14875,
		7,
		14875
	],
	"./ar-EG/_lib/formatDistance/index.js": [
		14875,
		7,
		14875
	],
	"./ar-EG/_lib/formatLong": [
		49434,
		7,
		29366
	],
	"./ar-EG/_lib/formatLong/": [
		49434,
		7,
		29366
	],
	"./ar-EG/_lib/formatLong/index": [
		49434,
		7,
		29366
	],
	"./ar-EG/_lib/formatLong/index.js": [
		49434,
		7,
		29366
	],
	"./ar-EG/_lib/formatRelative": [
		77828,
		7,
		77828
	],
	"./ar-EG/_lib/formatRelative/": [
		77828,
		7,
		77828
	],
	"./ar-EG/_lib/formatRelative/index": [
		77828,
		7,
		77828
	],
	"./ar-EG/_lib/formatRelative/index.js": [
		77828,
		7,
		77828
	],
	"./ar-EG/_lib/localize": [
		96046,
		7,
		96046
	],
	"./ar-EG/_lib/localize/": [
		96046,
		7,
		96046
	],
	"./ar-EG/_lib/localize/index": [
		96046,
		7,
		96046
	],
	"./ar-EG/_lib/localize/index.js": [
		96046,
		7,
		96046
	],
	"./ar-EG/_lib/match": [
		25144,
		7,
		25144
	],
	"./ar-EG/_lib/match/": [
		25144,
		7,
		25144
	],
	"./ar-EG/_lib/match/index": [
		25144,
		7,
		25144
	],
	"./ar-EG/_lib/match/index.js": [
		25144,
		7,
		25144
	],
	"./ar-EG/index": [
		91213,
		7,
		91213
	],
	"./ar-EG/index.d": [
		54430,
		9,
		54430
	],
	"./ar-EG/index.d.ts": [
		54430,
		9,
		54430
	],
	"./ar-EG/index.js": [
		91213,
		7,
		91213
	],
	"./ar-EG/index.js.flow": [
		77232,
		7,
		77232
	],
	"./ar-EG/package": [
		97938,
		3,
		97938
	],
	"./ar-EG/package.json": [
		97938,
		3,
		97938
	],
	"./ar-MA": [
		2435,
		9,
		55733
	],
	"./ar-MA/": [
		2435,
		9,
		55733
	],
	"./ar-MA/_lib/formatDistance": [
		67820,
		7,
		63779
	],
	"./ar-MA/_lib/formatDistance/": [
		67820,
		7,
		63779
	],
	"./ar-MA/_lib/formatDistance/index": [
		67820,
		7,
		63779
	],
	"./ar-MA/_lib/formatDistance/index.js": [
		67820,
		7,
		63779
	],
	"./ar-MA/_lib/formatLong": [
		33037,
		7,
		33037
	],
	"./ar-MA/_lib/formatLong/": [
		33037,
		7,
		33037
	],
	"./ar-MA/_lib/formatLong/index": [
		33037,
		7,
		33037
	],
	"./ar-MA/_lib/formatLong/index.js": [
		33037,
		7,
		33037
	],
	"./ar-MA/_lib/formatRelative": [
		88922,
		7,
		88922
	],
	"./ar-MA/_lib/formatRelative/": [
		88922,
		7,
		88922
	],
	"./ar-MA/_lib/formatRelative/index": [
		88922,
		7,
		88922
	],
	"./ar-MA/_lib/formatRelative/index.js": [
		88922,
		7,
		88922
	],
	"./ar-MA/_lib/localize": [
		69590,
		7,
		69590
	],
	"./ar-MA/_lib/localize/": [
		69590,
		7,
		69590
	],
	"./ar-MA/_lib/localize/index": [
		69590,
		7,
		69590
	],
	"./ar-MA/_lib/localize/index.js": [
		69590,
		7,
		69590
	],
	"./ar-MA/_lib/match": [
		29659,
		7,
		29659
	],
	"./ar-MA/_lib/match/": [
		29659,
		7,
		29659
	],
	"./ar-MA/_lib/match/index": [
		29659,
		7,
		29659
	],
	"./ar-MA/_lib/match/index.js": [
		29659,
		7,
		29659
	],
	"./ar-MA/index": [
		33687,
		7,
		33687
	],
	"./ar-MA/index.d": [
		55733,
		9,
		55733
	],
	"./ar-MA/index.d.ts": [
		55733,
		9,
		55733
	],
	"./ar-MA/index.js": [
		33687,
		7,
		33687
	],
	"./ar-MA/index.js.flow": [
		56639,
		7,
		56639
	],
	"./ar-MA/package": [
		7623,
		3,
		7623
	],
	"./ar-MA/package.json": [
		7623,
		3,
		7623
	],
	"./ar-SA": [
		13506,
		9,
		2775
	],
	"./ar-SA/": [
		13506,
		9,
		2775
	],
	"./ar-SA/_lib/formatDistance": [
		21857,
		7,
		21857
	],
	"./ar-SA/_lib/formatDistance/": [
		21857,
		7,
		21857
	],
	"./ar-SA/_lib/formatDistance/index": [
		21857,
		7,
		21857
	],
	"./ar-SA/_lib/formatDistance/index.js": [
		21857,
		7,
		21857
	],
	"./ar-SA/_lib/formatLong": [
		88273,
		7,
		88273
	],
	"./ar-SA/_lib/formatLong/": [
		88273,
		7,
		88273
	],
	"./ar-SA/_lib/formatLong/index": [
		88273,
		7,
		88273
	],
	"./ar-SA/_lib/formatLong/index.js": [
		88273,
		7,
		88273
	],
	"./ar-SA/_lib/formatRelative": [
		27333,
		7,
		27333
	],
	"./ar-SA/_lib/formatRelative/": [
		27333,
		7,
		27333
	],
	"./ar-SA/_lib/formatRelative/index": [
		27333,
		7,
		27333
	],
	"./ar-SA/_lib/formatRelative/index.js": [
		27333,
		7,
		27333
	],
	"./ar-SA/_lib/localize": [
		10607,
		7,
		10607
	],
	"./ar-SA/_lib/localize/": [
		10607,
		7,
		10607
	],
	"./ar-SA/_lib/localize/index": [
		10607,
		7,
		10607
	],
	"./ar-SA/_lib/localize/index.js": [
		10607,
		7,
		10607
	],
	"./ar-SA/_lib/match": [
		84826,
		7,
		84826
	],
	"./ar-SA/_lib/match/": [
		84826,
		7,
		84826
	],
	"./ar-SA/_lib/match/index": [
		84826,
		7,
		84826
	],
	"./ar-SA/_lib/match/index.js": [
		84826,
		7,
		84826
	],
	"./ar-SA/index": [
		85648,
		7,
		85648
	],
	"./ar-SA/index.d": [
		2775,
		9,
		2775
	],
	"./ar-SA/index.d.ts": [
		2775,
		9,
		2775
	],
	"./ar-SA/index.js": [
		85648,
		7,
		85648
	],
	"./ar-SA/index.js.flow": [
		89089,
		7,
		89089
	],
	"./ar-SA/package": [
		26905,
		3,
		26905
	],
	"./ar-SA/package.json": [
		26905,
		3,
		26905
	],
	"./ar-TN": [
		38517,
		9,
		63414
	],
	"./ar-TN/": [
		38517,
		9,
		63414
	],
	"./ar-TN/_lib/formatDistance": [
		22358,
		7,
		22358
	],
	"./ar-TN/_lib/formatDistance/": [
		22358,
		7,
		22358
	],
	"./ar-TN/_lib/formatDistance/index": [
		22358,
		7,
		22358
	],
	"./ar-TN/_lib/formatDistance/index.js": [
		22358,
		7,
		22358
	],
	"./ar-TN/_lib/formatLong": [
		36726,
		7,
		36726
	],
	"./ar-TN/_lib/formatLong/": [
		36726,
		7,
		36726
	],
	"./ar-TN/_lib/formatLong/index": [
		36726,
		7,
		36726
	],
	"./ar-TN/_lib/formatLong/index.js": [
		36726,
		7,
		36726
	],
	"./ar-TN/_lib/formatRelative": [
		76163,
		7,
		76163
	],
	"./ar-TN/_lib/formatRelative/": [
		76163,
		7,
		76163
	],
	"./ar-TN/_lib/formatRelative/index": [
		76163,
		7,
		76163
	],
	"./ar-TN/_lib/formatRelative/index.js": [
		76163,
		7,
		76163
	],
	"./ar-TN/_lib/localize": [
		65370,
		7,
		65370
	],
	"./ar-TN/_lib/localize/": [
		65370,
		7,
		65370
	],
	"./ar-TN/_lib/localize/index": [
		65370,
		7,
		65370
	],
	"./ar-TN/_lib/localize/index.js": [
		65370,
		7,
		65370
	],
	"./ar-TN/_lib/match": [
		60483,
		7,
		60483
	],
	"./ar-TN/_lib/match/": [
		60483,
		7,
		60483
	],
	"./ar-TN/_lib/match/index": [
		60483,
		7,
		60483
	],
	"./ar-TN/_lib/match/index.js": [
		60483,
		7,
		60483
	],
	"./ar-TN/index": [
		55394,
		7,
		55394
	],
	"./ar-TN/index.d": [
		63414,
		9,
		63414
	],
	"./ar-TN/index.d.ts": [
		63414,
		9,
		63414
	],
	"./ar-TN/index.js": [
		55394,
		7,
		55394
	],
	"./ar-TN/index.js.flow": [
		66295,
		7,
		25803
	],
	"./ar-TN/package": [
		80960,
		3,
		80960
	],
	"./ar-TN/package.json": [
		80960,
		3,
		80960
	],
	"./ar/": [
		2826,
		9,
		97053
	],
	"./ar/_lib/formatDistance": [
		40429,
		7,
		40429
	],
	"./ar/_lib/formatDistance/": [
		40429,
		7,
		40429
	],
	"./ar/_lib/formatDistance/index": [
		40429,
		7,
		40429
	],
	"./ar/_lib/formatDistance/index.js": [
		40429,
		7,
		40429
	],
	"./ar/_lib/formatLong": [
		11317,
		7,
		11317
	],
	"./ar/_lib/formatLong/": [
		11317,
		7,
		11317
	],
	"./ar/_lib/formatLong/index": [
		11317,
		7,
		11317
	],
	"./ar/_lib/formatLong/index.js": [
		11317,
		7,
		11317
	],
	"./ar/_lib/formatRelative": [
		15979,
		7,
		15979
	],
	"./ar/_lib/formatRelative/": [
		15979,
		7,
		15979
	],
	"./ar/_lib/formatRelative/index": [
		15979,
		7,
		15979
	],
	"./ar/_lib/formatRelative/index.js": [
		15979,
		7,
		15979
	],
	"./ar/_lib/localize": [
		52836,
		7,
		52836
	],
	"./ar/_lib/localize/": [
		52836,
		7,
		52836
	],
	"./ar/_lib/localize/index": [
		52836,
		7,
		52836
	],
	"./ar/_lib/localize/index.js": [
		52836,
		7,
		52836
	],
	"./ar/_lib/match": [
		17280,
		7,
		17280
	],
	"./ar/_lib/match/": [
		17280,
		7,
		17280
	],
	"./ar/_lib/match/index": [
		17280,
		7,
		17280
	],
	"./ar/_lib/match/index.js": [
		17280,
		7,
		17280
	],
	"./ar/index": [
		48378,
		7,
		48378
	],
	"./ar/index.d": [
		97053,
		9,
		97053
	],
	"./ar/index.d.ts": [
		97053,
		9,
		97053
	],
	"./ar/index.js": [
		48378,
		7,
		48378
	],
	"./ar/index.js.flow": [
		60520,
		7,
		60520
	],
	"./ar/package": [
		69563,
		3,
		69563
	],
	"./ar/package.json": [
		69563,
		3,
		69563
	],
	"./az": [
		53959,
		9,
		99006
	],
	"./az/": [
		53959,
		9,
		99006
	],
	"./az/_lib/formatDistance": [
		1020,
		7,
		1020
	],
	"./az/_lib/formatDistance/": [
		1020,
		7,
		1020
	],
	"./az/_lib/formatDistance/index": [
		1020,
		7,
		1020
	],
	"./az/_lib/formatDistance/index.js": [
		1020,
		7,
		1020
	],
	"./az/_lib/formatLong": [
		659,
		7,
		659
	],
	"./az/_lib/formatLong/": [
		659,
		7,
		659
	],
	"./az/_lib/formatLong/index": [
		659,
		7,
		659
	],
	"./az/_lib/formatLong/index.js": [
		659,
		7,
		659
	],
	"./az/_lib/formatRelative": [
		40229,
		7,
		40229
	],
	"./az/_lib/formatRelative/": [
		40229,
		7,
		40229
	],
	"./az/_lib/formatRelative/index": [
		40229,
		7,
		40229
	],
	"./az/_lib/formatRelative/index.js": [
		40229,
		7,
		40229
	],
	"./az/_lib/localize": [
		84242,
		7,
		84242
	],
	"./az/_lib/localize/": [
		84242,
		7,
		84242
	],
	"./az/_lib/localize/index": [
		84242,
		7,
		84242
	],
	"./az/_lib/localize/index.js": [
		84242,
		7,
		84242
	],
	"./az/_lib/match": [
		16002,
		7,
		16002
	],
	"./az/_lib/match/": [
		16002,
		7,
		16002
	],
	"./az/_lib/match/index": [
		16002,
		7,
		16002
	],
	"./az/_lib/match/index.js": [
		16002,
		7,
		16002
	],
	"./az/index": [
		6251,
		7,
		6251
	],
	"./az/index.d": [
		99006,
		9,
		99006
	],
	"./az/index.d.ts": [
		99006,
		9,
		99006
	],
	"./az/index.js": [
		6251,
		7,
		6251
	],
	"./az/index.js.flow": [
		99665,
		7,
		99665
	],
	"./az/package": [
		96713,
		3,
		96713
	],
	"./az/package.json": [
		96713,
		3,
		96713
	],
	"./be": [
		82774,
		9,
		38474
	],
	"./be-tarask": [
		62202,
		9,
		35839
	],
	"./be-tarask/": [
		62202,
		9,
		35839
	],
	"./be-tarask/_lib/formatDistance": [
		8835,
		7,
		8835
	],
	"./be-tarask/_lib/formatDistance/": [
		8835,
		7,
		8835
	],
	"./be-tarask/_lib/formatDistance/index": [
		8835,
		7,
		8835
	],
	"./be-tarask/_lib/formatDistance/index.js": [
		8835,
		7,
		8835
	],
	"./be-tarask/_lib/formatLong": [
		33297,
		7,
		33297
	],
	"./be-tarask/_lib/formatLong/": [
		33297,
		7,
		33297
	],
	"./be-tarask/_lib/formatLong/index": [
		33297,
		7,
		33297
	],
	"./be-tarask/_lib/formatLong/index.js": [
		33297,
		7,
		33297
	],
	"./be-tarask/_lib/formatRelative": [
		66165,
		7,
		76566
	],
	"./be-tarask/_lib/formatRelative/": [
		66165,
		7,
		76566
	],
	"./be-tarask/_lib/formatRelative/index": [
		66165,
		7,
		76566
	],
	"./be-tarask/_lib/formatRelative/index.js": [
		66165,
		7,
		76566
	],
	"./be-tarask/_lib/localize": [
		76337,
		7,
		76337
	],
	"./be-tarask/_lib/localize/": [
		76337,
		7,
		76337
	],
	"./be-tarask/_lib/localize/index": [
		76337,
		7,
		76337
	],
	"./be-tarask/_lib/localize/index.js": [
		76337,
		7,
		76337
	],
	"./be-tarask/_lib/match": [
		35822,
		7,
		35822
	],
	"./be-tarask/_lib/match/": [
		35822,
		7,
		35822
	],
	"./be-tarask/_lib/match/index": [
		35822,
		7,
		35822
	],
	"./be-tarask/_lib/match/index.js": [
		35822,
		7,
		35822
	],
	"./be-tarask/index": [
		12273,
		7,
		76566
	],
	"./be-tarask/index.d": [
		35839,
		9,
		35839
	],
	"./be-tarask/index.d.ts": [
		35839,
		9,
		35839
	],
	"./be-tarask/index.js": [
		12273,
		7,
		76566
	],
	"./be-tarask/index.js.flow": [
		62579,
		7,
		62579
	],
	"./be-tarask/package": [
		64037,
		3,
		64037
	],
	"./be-tarask/package.json": [
		64037,
		3,
		64037
	],
	"./be/": [
		82774,
		9,
		38474
	],
	"./be/_lib/formatDistance": [
		99853,
		7,
		99853
	],
	"./be/_lib/formatDistance/": [
		99853,
		7,
		99853
	],
	"./be/_lib/formatDistance/index": [
		99853,
		7,
		99853
	],
	"./be/_lib/formatDistance/index.js": [
		99853,
		7,
		99853
	],
	"./be/_lib/formatLong": [
		65806,
		7,
		65806
	],
	"./be/_lib/formatLong/": [
		65806,
		7,
		65806
	],
	"./be/_lib/formatLong/index": [
		65806,
		7,
		65806
	],
	"./be/_lib/formatLong/index.js": [
		65806,
		7,
		65806
	],
	"./be/_lib/formatRelative": [
		18196,
		7,
		76566
	],
	"./be/_lib/formatRelative/": [
		18196,
		7,
		76566
	],
	"./be/_lib/formatRelative/index": [
		18196,
		7,
		76566
	],
	"./be/_lib/formatRelative/index.js": [
		18196,
		7,
		76566
	],
	"./be/_lib/localize": [
		50634,
		7,
		50634
	],
	"./be/_lib/localize/": [
		50634,
		7,
		50634
	],
	"./be/_lib/localize/index": [
		50634,
		7,
		50634
	],
	"./be/_lib/localize/index.js": [
		50634,
		7,
		50634
	],
	"./be/_lib/match": [
		30454,
		7,
		30454
	],
	"./be/_lib/match/": [
		30454,
		7,
		30454
	],
	"./be/_lib/match/index": [
		30454,
		7,
		30454
	],
	"./be/_lib/match/index.js": [
		30454,
		7,
		30454
	],
	"./be/index": [
		70547,
		7,
		76566
	],
	"./be/index.d": [
		38474,
		9,
		38474
	],
	"./be/index.d.ts": [
		38474,
		9,
		38474
	],
	"./be/index.js": [
		70547,
		7,
		76566
	],
	"./be/index.js.flow": [
		35290,
		7,
		35290
	],
	"./be/package": [
		70136,
		3,
		70136
	],
	"./be/package.json": [
		70136,
		3,
		70136
	],
	"./bg": [
		66435,
		9,
		68491
	],
	"./bg/": [
		66435,
		9,
		68491
	],
	"./bg/_lib/formatDistance": [
		4539,
		7,
		4539
	],
	"./bg/_lib/formatDistance/": [
		4539,
		7,
		4539
	],
	"./bg/_lib/formatDistance/index": [
		4539,
		7,
		4539
	],
	"./bg/_lib/formatDistance/index.js": [
		4539,
		7,
		4539
	],
	"./bg/_lib/formatLong": [
		51884,
		7,
		82924
	],
	"./bg/_lib/formatLong/": [
		51884,
		7,
		82924
	],
	"./bg/_lib/formatLong/index": [
		51884,
		7,
		82924
	],
	"./bg/_lib/formatLong/index.js": [
		51884,
		7,
		82924
	],
	"./bg/_lib/formatRelative": [
		90620,
		7,
		73464
	],
	"./bg/_lib/formatRelative/": [
		90620,
		7,
		73464
	],
	"./bg/_lib/formatRelative/index": [
		90620,
		7,
		73464
	],
	"./bg/_lib/formatRelative/index.js": [
		90620,
		7,
		73464
	],
	"./bg/_lib/localize": [
		43109,
		7,
		43109
	],
	"./bg/_lib/localize/": [
		43109,
		7,
		43109
	],
	"./bg/_lib/localize/index": [
		43109,
		7,
		43109
	],
	"./bg/_lib/localize/index.js": [
		43109,
		7,
		43109
	],
	"./bg/_lib/match": [
		16550,
		7,
		16550
	],
	"./bg/_lib/match/": [
		16550,
		7,
		16550
	],
	"./bg/_lib/match/index": [
		16550,
		7,
		16550
	],
	"./bg/_lib/match/index.js": [
		16550,
		7,
		16550
	],
	"./bg/index": [
		23720,
		7,
		23720
	],
	"./bg/index.d": [
		68491,
		9,
		68491
	],
	"./bg/index.d.ts": [
		68491,
		9,
		68491
	],
	"./bg/index.js": [
		23720,
		7,
		23720
	],
	"./bg/index.js.flow": [
		69542,
		7,
		69542
	],
	"./bg/package": [
		83751,
		3,
		63986
	],
	"./bg/package.json": [
		83751,
		3,
		63986
	],
	"./bn": [
		29481,
		9,
		6522
	],
	"./bn/": [
		29481,
		9,
		6522
	],
	"./bn/_lib/formatDistance": [
		71575,
		7,
		71575
	],
	"./bn/_lib/formatDistance/": [
		71575,
		7,
		71575
	],
	"./bn/_lib/formatDistance/index": [
		71575,
		7,
		71575
	],
	"./bn/_lib/formatDistance/index.js": [
		71575,
		7,
		71575
	],
	"./bn/_lib/formatLong": [
		11030,
		7,
		11030
	],
	"./bn/_lib/formatLong/": [
		11030,
		7,
		11030
	],
	"./bn/_lib/formatLong/index": [
		11030,
		7,
		11030
	],
	"./bn/_lib/formatLong/index.js": [
		11030,
		7,
		11030
	],
	"./bn/_lib/formatRelative": [
		69117,
		7,
		69117
	],
	"./bn/_lib/formatRelative/": [
		69117,
		7,
		69117
	],
	"./bn/_lib/formatRelative/index": [
		69117,
		7,
		69117
	],
	"./bn/_lib/formatRelative/index.js": [
		69117,
		7,
		69117
	],
	"./bn/_lib/localize": [
		96838,
		7,
		71575
	],
	"./bn/_lib/localize/": [
		96838,
		7,
		71575
	],
	"./bn/_lib/localize/index": [
		96838,
		7,
		71575
	],
	"./bn/_lib/localize/index.js": [
		96838,
		7,
		71575
	],
	"./bn/_lib/match": [
		45963,
		7,
		45963
	],
	"./bn/_lib/match/": [
		45963,
		7,
		45963
	],
	"./bn/_lib/match/index": [
		45963,
		7,
		45963
	],
	"./bn/_lib/match/index.js": [
		45963,
		7,
		45963
	],
	"./bn/index": [
		61555,
		7,
		61555
	],
	"./bn/index.d": [
		6522,
		9,
		6522
	],
	"./bn/index.d.ts": [
		6522,
		9,
		6522
	],
	"./bn/index.js": [
		61555,
		7,
		61555
	],
	"./bn/index.js.flow": [
		21881,
		7,
		21881
	],
	"./bn/package": [
		9958,
		3,
		9958
	],
	"./bn/package.json": [
		9958,
		3,
		9958
	],
	"./bs": [
		93363,
		9,
		56431
	],
	"./bs/": [
		93363,
		9,
		56431
	],
	"./bs/_lib/formatDistance": [
		71645,
		7,
		71645
	],
	"./bs/_lib/formatDistance/": [
		71645,
		7,
		71645
	],
	"./bs/_lib/formatDistance/index": [
		71645,
		7,
		71645
	],
	"./bs/_lib/formatDistance/index.js": [
		71645,
		7,
		71645
	],
	"./bs/_lib/formatLong": [
		21862,
		7,
		21862
	],
	"./bs/_lib/formatLong/": [
		21862,
		7,
		21862
	],
	"./bs/_lib/formatLong/index": [
		21862,
		7,
		21862
	],
	"./bs/_lib/formatLong/index.js": [
		21862,
		7,
		21862
	],
	"./bs/_lib/formatRelative": [
		1212,
		7,
		1212
	],
	"./bs/_lib/formatRelative/": [
		1212,
		7,
		1212
	],
	"./bs/_lib/formatRelative/index": [
		1212,
		7,
		1212
	],
	"./bs/_lib/formatRelative/index.js": [
		1212,
		7,
		1212
	],
	"./bs/_lib/localize": [
		62178,
		7,
		62178
	],
	"./bs/_lib/localize/": [
		62178,
		7,
		62178
	],
	"./bs/_lib/localize/index": [
		62178,
		7,
		62178
	],
	"./bs/_lib/localize/index.js": [
		62178,
		7,
		62178
	],
	"./bs/_lib/match": [
		44451,
		7,
		44451
	],
	"./bs/_lib/match/": [
		44451,
		7,
		44451
	],
	"./bs/_lib/match/index": [
		44451,
		7,
		44451
	],
	"./bs/_lib/match/index.js": [
		44451,
		7,
		44451
	],
	"./bs/index": [
		55786,
		7,
		55786
	],
	"./bs/index.d": [
		56431,
		9,
		56431
	],
	"./bs/index.d.ts": [
		56431,
		9,
		56431
	],
	"./bs/index.js": [
		55786,
		7,
		55786
	],
	"./bs/index.js.flow": [
		87228,
		7,
		87228
	],
	"./bs/package": [
		43562,
		3,
		43562
	],
	"./bs/package.json": [
		43562,
		3,
		43562
	],
	"./ca": [
		24251,
		9,
		84954
	],
	"./ca/": [
		24251,
		9,
		84954
	],
	"./ca/_lib/formatDistance": [
		69611,
		7,
		69611
	],
	"./ca/_lib/formatDistance/": [
		69611,
		7,
		69611
	],
	"./ca/_lib/formatDistance/index": [
		69611,
		7,
		69611
	],
	"./ca/_lib/formatDistance/index.js": [
		69611,
		7,
		69611
	],
	"./ca/_lib/formatLong": [
		52032,
		7,
		52032
	],
	"./ca/_lib/formatLong/": [
		52032,
		7,
		52032
	],
	"./ca/_lib/formatLong/index": [
		52032,
		7,
		52032
	],
	"./ca/_lib/formatLong/index.js": [
		52032,
		7,
		52032
	],
	"./ca/_lib/formatRelative": [
		88113,
		7,
		88113
	],
	"./ca/_lib/formatRelative/": [
		88113,
		7,
		88113
	],
	"./ca/_lib/formatRelative/index": [
		88113,
		7,
		88113
	],
	"./ca/_lib/formatRelative/index.js": [
		88113,
		7,
		88113
	],
	"./ca/_lib/localize": [
		24322,
		7,
		24322
	],
	"./ca/_lib/localize/": [
		24322,
		7,
		24322
	],
	"./ca/_lib/localize/index": [
		24322,
		7,
		24322
	],
	"./ca/_lib/localize/index.js": [
		24322,
		7,
		24322
	],
	"./ca/_lib/match": [
		9103,
		7,
		9103
	],
	"./ca/_lib/match/": [
		9103,
		7,
		9103
	],
	"./ca/_lib/match/index": [
		9103,
		7,
		9103
	],
	"./ca/_lib/match/index.js": [
		9103,
		7,
		9103
	],
	"./ca/index": [
		87257,
		7,
		87257
	],
	"./ca/index.d": [
		84954,
		9,
		84954
	],
	"./ca/index.d.ts": [
		84954,
		9,
		84954
	],
	"./ca/index.js": [
		87257,
		7,
		87257
	],
	"./ca/index.js.flow": [
		93611,
		7,
		93611
	],
	"./ca/package": [
		39609,
		3,
		39609
	],
	"./ca/package.json": [
		39609,
		3,
		39609
	],
	"./cs": [
		69479,
		9,
		73667
	],
	"./cs/": [
		69479,
		9,
		73667
	],
	"./cs/_lib/formatDistance": [
		57813,
		7,
		57813
	],
	"./cs/_lib/formatDistance/": [
		57813,
		7,
		57813
	],
	"./cs/_lib/formatDistance/index": [
		57813,
		7,
		57813
	],
	"./cs/_lib/formatDistance/index.js": [
		57813,
		7,
		57813
	],
	"./cs/_lib/formatLong": [
		47909,
		7,
		47909
	],
	"./cs/_lib/formatLong/": [
		47909,
		7,
		47909
	],
	"./cs/_lib/formatLong/index": [
		47909,
		7,
		47909
	],
	"./cs/_lib/formatLong/index.js": [
		47909,
		7,
		47909
	],
	"./cs/_lib/formatRelative": [
		47964,
		7,
		47964
	],
	"./cs/_lib/formatRelative/": [
		47964,
		7,
		47964
	],
	"./cs/_lib/formatRelative/index": [
		47964,
		7,
		47964
	],
	"./cs/_lib/formatRelative/index.js": [
		47964,
		7,
		47964
	],
	"./cs/_lib/localize": [
		62517,
		7,
		62517
	],
	"./cs/_lib/localize/": [
		62517,
		7,
		62517
	],
	"./cs/_lib/localize/index": [
		62517,
		7,
		62517
	],
	"./cs/_lib/localize/index.js": [
		62517,
		7,
		62517
	],
	"./cs/_lib/match": [
		49061,
		7,
		49061
	],
	"./cs/_lib/match/": [
		49061,
		7,
		49061
	],
	"./cs/_lib/match/index": [
		49061,
		7,
		49061
	],
	"./cs/_lib/match/index.js": [
		49061,
		7,
		49061
	],
	"./cs/index": [
		78316,
		7,
		78316
	],
	"./cs/index.d": [
		73667,
		9,
		73667
	],
	"./cs/index.d.ts": [
		73667,
		9,
		73667
	],
	"./cs/index.js": [
		78316,
		7,
		78316
	],
	"./cs/index.js.flow": [
		72170,
		7,
		72170
	],
	"./cs/package": [
		81630,
		3,
		81630
	],
	"./cs/package.json": [
		81630,
		3,
		81630
	],
	"./cy": [
		27813,
		9,
		73198
	],
	"./cy/": [
		27813,
		9,
		73198
	],
	"./cy/_lib/formatDistance": [
		56710,
		7,
		56710
	],
	"./cy/_lib/formatDistance/": [
		56710,
		7,
		56710
	],
	"./cy/_lib/formatDistance/index": [
		56710,
		7,
		56710
	],
	"./cy/_lib/formatDistance/index.js": [
		56710,
		7,
		56710
	],
	"./cy/_lib/formatLong": [
		65600,
		7,
		65600
	],
	"./cy/_lib/formatLong/": [
		65600,
		7,
		65600
	],
	"./cy/_lib/formatLong/index": [
		65600,
		7,
		65600
	],
	"./cy/_lib/formatLong/index.js": [
		65600,
		7,
		65600
	],
	"./cy/_lib/formatRelative": [
		7749,
		7,
		7749
	],
	"./cy/_lib/formatRelative/": [
		7749,
		7,
		7749
	],
	"./cy/_lib/formatRelative/index": [
		7749,
		7,
		7749
	],
	"./cy/_lib/formatRelative/index.js": [
		7749,
		7,
		7749
	],
	"./cy/_lib/localize": [
		18153,
		7,
		18153
	],
	"./cy/_lib/localize/": [
		18153,
		7,
		18153
	],
	"./cy/_lib/localize/index": [
		18153,
		7,
		18153
	],
	"./cy/_lib/localize/index.js": [
		18153,
		7,
		18153
	],
	"./cy/_lib/match": [
		6054,
		7,
		6054
	],
	"./cy/_lib/match/": [
		6054,
		7,
		6054
	],
	"./cy/_lib/match/index": [
		6054,
		7,
		6054
	],
	"./cy/_lib/match/index.js": [
		6054,
		7,
		6054
	],
	"./cy/index": [
		86321,
		7,
		86321
	],
	"./cy/index.d": [
		3996,
		9,
		73198
	],
	"./cy/index.d.ts": [
		3996,
		9,
		73198
	],
	"./cy/index.js": [
		86321,
		7,
		86321
	],
	"./cy/index.js.flow": [
		33066,
		7,
		33066
	],
	"./cy/package": [
		5912,
		3,
		5912
	],
	"./cy/package.json": [
		5912,
		3,
		5912
	],
	"./da": [
		54721,
		9,
		63511
	],
	"./da/": [
		54721,
		9,
		63511
	],
	"./da/_lib/formatDistance": [
		61273,
		7,
		61273
	],
	"./da/_lib/formatDistance/": [
		61273,
		7,
		61273
	],
	"./da/_lib/formatDistance/index": [
		61273,
		7,
		61273
	],
	"./da/_lib/formatDistance/index.js": [
		61273,
		7,
		61273
	],
	"./da/_lib/formatLong": [
		16131,
		7,
		16131
	],
	"./da/_lib/formatLong/": [
		16131,
		7,
		16131
	],
	"./da/_lib/formatLong/index": [
		16131,
		7,
		16131
	],
	"./da/_lib/formatLong/index.js": [
		16131,
		7,
		16131
	],
	"./da/_lib/formatRelative": [
		96065,
		7,
		96065
	],
	"./da/_lib/formatRelative/": [
		96065,
		7,
		96065
	],
	"./da/_lib/formatRelative/index": [
		96065,
		7,
		96065
	],
	"./da/_lib/formatRelative/index.js": [
		96065,
		7,
		96065
	],
	"./da/_lib/localize": [
		51744,
		7,
		51744
	],
	"./da/_lib/localize/": [
		51744,
		7,
		51744
	],
	"./da/_lib/localize/index": [
		51744,
		7,
		51744
	],
	"./da/_lib/localize/index.js": [
		51744,
		7,
		51744
	],
	"./da/_lib/match": [
		75083,
		7,
		75083
	],
	"./da/_lib/match/": [
		75083,
		7,
		75083
	],
	"./da/_lib/match/index": [
		75083,
		7,
		75083
	],
	"./da/_lib/match/index.js": [
		75083,
		7,
		75083
	],
	"./da/index": [
		15110,
		7,
		15110
	],
	"./da/index.d": [
		63511,
		9,
		63511
	],
	"./da/index.d.ts": [
		63511,
		9,
		63511
	],
	"./da/index.js": [
		15110,
		7,
		15110
	],
	"./da/index.js.flow": [
		98591,
		7,
		98591
	],
	"./da/package": [
		2897,
		3,
		2897
	],
	"./da/package.json": [
		2897,
		3,
		2897
	],
	"./de": [
		17330,
		9,
		35679
	],
	"./de-AT": [
		2107,
		9,
		91135
	],
	"./de-AT/": [
		2107,
		9,
		91135
	],
	"./de-AT/_lib/localize": [
		25789,
		7,
		25789
	],
	"./de-AT/_lib/localize/": [
		25789,
		7,
		25789
	],
	"./de-AT/_lib/localize/index": [
		25789,
		7,
		25789
	],
	"./de-AT/_lib/localize/index.js": [
		25789,
		7,
		25789
	],
	"./de-AT/index": [
		90604,
		7,
		97375
	],
	"./de-AT/index.d": [
		91135,
		9,
		91135
	],
	"./de-AT/index.d.ts": [
		91135,
		9,
		91135
	],
	"./de-AT/index.js": [
		90604,
		7,
		97375
	],
	"./de-AT/index.js.flow": [
		38119,
		7,
		65137
	],
	"./de-AT/package": [
		66159,
		3,
		66159
	],
	"./de-AT/package.json": [
		66159,
		3,
		66159
	],
	"./de/": [
		17330,
		9,
		35679
	],
	"./de/_lib/formatDistance": [
		46586,
		7,
		46586
	],
	"./de/_lib/formatDistance/": [
		46586,
		7,
		46586
	],
	"./de/_lib/formatDistance/index": [
		46586,
		7,
		46586
	],
	"./de/_lib/formatDistance/index.js": [
		46586,
		7,
		46586
	],
	"./de/_lib/formatLong": [
		73906,
		7,
		73906
	],
	"./de/_lib/formatLong/": [
		73906,
		7,
		73906
	],
	"./de/_lib/formatLong/index": [
		73906,
		7,
		73906
	],
	"./de/_lib/formatLong/index.js": [
		73906,
		7,
		73906
	],
	"./de/_lib/formatRelative": [
		95150,
		7,
		95150
	],
	"./de/_lib/formatRelative/": [
		95150,
		7,
		95150
	],
	"./de/_lib/formatRelative/index": [
		95150,
		7,
		95150
	],
	"./de/_lib/formatRelative/index.js": [
		95150,
		7,
		95150
	],
	"./de/_lib/localize": [
		45465,
		7,
		45465
	],
	"./de/_lib/localize/": [
		45465,
		7,
		45465
	],
	"./de/_lib/localize/index": [
		45465,
		7,
		45465
	],
	"./de/_lib/localize/index.js": [
		45465,
		7,
		45465
	],
	"./de/_lib/match": [
		53196,
		7,
		53196
	],
	"./de/_lib/match/": [
		53196,
		7,
		53196
	],
	"./de/_lib/match/index": [
		53196,
		7,
		53196
	],
	"./de/_lib/match/index.js": [
		53196,
		7,
		53196
	],
	"./de/index": [
		92519,
		7,
		97375
	],
	"./de/index.d": [
		35679,
		9,
		35679
	],
	"./de/index.d.ts": [
		35679,
		9,
		35679
	],
	"./de/index.js": [
		92519,
		7,
		97375
	],
	"./de/index.js.flow": [
		85865,
		7,
		85865
	],
	"./de/package": [
		1136,
		3,
		1136
	],
	"./de/package.json": [
		1136,
		3,
		1136
	],
	"./el": [
		26434,
		9,
		48756
	],
	"./el/": [
		26434,
		9,
		48756
	],
	"./el/_lib/formatDistance": [
		52542,
		7,
		52542
	],
	"./el/_lib/formatDistance/": [
		52542,
		7,
		52542
	],
	"./el/_lib/formatDistance/index": [
		52542,
		7,
		52542
	],
	"./el/_lib/formatDistance/index.js": [
		52542,
		7,
		52542
	],
	"./el/_lib/formatLong": [
		75789,
		7,
		75789
	],
	"./el/_lib/formatLong/": [
		75789,
		7,
		75789
	],
	"./el/_lib/formatLong/index": [
		75789,
		7,
		75789
	],
	"./el/_lib/formatLong/index.js": [
		75789,
		7,
		75789
	],
	"./el/_lib/formatRelative": [
		38339,
		7,
		38339
	],
	"./el/_lib/formatRelative/": [
		38339,
		7,
		38339
	],
	"./el/_lib/formatRelative/index": [
		38339,
		7,
		38339
	],
	"./el/_lib/formatRelative/index.js": [
		38339,
		7,
		38339
	],
	"./el/_lib/localize": [
		1522,
		7,
		1522
	],
	"./el/_lib/localize/": [
		1522,
		7,
		1522
	],
	"./el/_lib/localize/index": [
		1522,
		7,
		1522
	],
	"./el/_lib/localize/index.js": [
		1522,
		7,
		1522
	],
	"./el/_lib/match": [
		56707,
		7,
		56707
	],
	"./el/_lib/match/": [
		56707,
		7,
		56707
	],
	"./el/_lib/match/index": [
		56707,
		7,
		56707
	],
	"./el/_lib/match/index.js": [
		56707,
		7,
		56707
	],
	"./el/index": [
		28133,
		7,
		28133
	],
	"./el/index.d": [
		48756,
		9,
		48756
	],
	"./el/index.d.ts": [
		48756,
		9,
		48756
	],
	"./el/index.js": [
		28133,
		7,
		28133
	],
	"./el/index.js.flow": [
		87304,
		7,
		87304
	],
	"./el/package": [
		67896,
		3,
		67896
	],
	"./el/package.json": [
		67896,
		3,
		67896
	],
	"./en-AU": [
		65723,
		9,
		25861
	],
	"./en-AU/": [
		65723,
		9,
		25861
	],
	"./en-AU/_lib/formatLong": [
		64149,
		7,
		64149
	],
	"./en-AU/_lib/formatLong/": [
		64149,
		7,
		64149
	],
	"./en-AU/_lib/formatLong/index": [
		64149,
		7,
		64149
	],
	"./en-AU/_lib/formatLong/index.js": [
		64149,
		7,
		64149
	],
	"./en-AU/index": [
		51736,
		7,
		9028
	],
	"./en-AU/index.d": [
		25861,
		9,
		25861
	],
	"./en-AU/index.d.ts": [
		25861,
		9,
		25861
	],
	"./en-AU/index.js": [
		51736,
		7,
		9028
	],
	"./en-AU/index.js.flow": [
		74524,
		7,
		74524
	],
	"./en-AU/package": [
		87445,
		3,
		87445
	],
	"./en-AU/package.json": [
		87445,
		3,
		87445
	],
	"./en-CA": [
		45850,
		9,
		77560
	],
	"./en-CA/": [
		45850,
		9,
		77560
	],
	"./en-CA/_lib/formatDistance": [
		70039,
		7,
		70039
	],
	"./en-CA/_lib/formatDistance/": [
		70039,
		7,
		70039
	],
	"./en-CA/_lib/formatDistance/index": [
		70039,
		7,
		70039
	],
	"./en-CA/_lib/formatDistance/index.js": [
		70039,
		7,
		70039
	],
	"./en-CA/_lib/formatLong": [
		33304,
		7,
		33304
	],
	"./en-CA/_lib/formatLong/": [
		33304,
		7,
		33304
	],
	"./en-CA/_lib/formatLong/index": [
		33304,
		7,
		33304
	],
	"./en-CA/_lib/formatLong/index.js": [
		33304,
		7,
		33304
	],
	"./en-CA/index": [
		29194,
		7,
		37748
	],
	"./en-CA/index.d": [
		77560,
		9,
		77560
	],
	"./en-CA/index.d.ts": [
		77560,
		9,
		77560
	],
	"./en-CA/index.js": [
		29194,
		7,
		37748
	],
	"./en-CA/index.js.flow": [
		96873,
		7,
		96873
	],
	"./en-CA/package": [
		61714,
		3,
		61714
	],
	"./en-CA/package.json": [
		61714,
		3,
		61714
	],
	"./en-GB": [
		44149,
		9,
		41333
	],
	"./en-GB/": [
		44149,
		9,
		41333
	],
	"./en-GB/_lib/formatLong": [
		95747,
		7,
		95747
	],
	"./en-GB/_lib/formatLong/": [
		95747,
		7,
		95747
	],
	"./en-GB/_lib/formatLong/index": [
		95747,
		7,
		95747
	],
	"./en-GB/_lib/formatLong/index.js": [
		95747,
		7,
		95747
	],
	"./en-GB/index": [
		7645,
		7,
		37748
	],
	"./en-GB/index.d": [
		41333,
		9,
		41333
	],
	"./en-GB/index.d.ts": [
		41333,
		9,
		41333
	],
	"./en-GB/index.js": [
		7645,
		7,
		37748
	],
	"./en-GB/index.js.flow": [
		68349,
		7,
		68349
	],
	"./en-GB/package": [
		79204,
		3,
		79204
	],
	"./en-GB/package.json": [
		79204,
		3,
		79204
	],
	"./en-IE": [
		1163,
		9,
		69459
	],
	"./en-IE/": [
		1163,
		9,
		69459
	],
	"./en-IE/index": [
		68303,
		7,
		37748
	],
	"./en-IE/index.d": [
		69459,
		9,
		69459
	],
	"./en-IE/index.d.ts": [
		69459,
		9,
		69459
	],
	"./en-IE/index.js": [
		68303,
		7,
		37748
	],
	"./en-IE/index.js.flow": [
		71412,
		7,
		71412
	],
	"./en-IE/package": [
		98472,
		3,
		98472
	],
	"./en-IE/package.json": [
		98472,
		3,
		98472
	],
	"./en-IN": [
		7376,
		9,
		98141
	],
	"./en-IN/": [
		7376,
		9,
		98141
	],
	"./en-IN/_lib/formatLong": [
		79863,
		7,
		79863
	],
	"./en-IN/_lib/formatLong/": [
		79863,
		7,
		79863
	],
	"./en-IN/_lib/formatLong/index": [
		79863,
		7,
		79863
	],
	"./en-IN/_lib/formatLong/index.js": [
		79863,
		7,
		79863
	],
	"./en-IN/index": [
		46692,
		7,
		37748
	],
	"./en-IN/index.d": [
		98141,
		9,
		98141
	],
	"./en-IN/index.d.ts": [
		98141,
		9,
		98141
	],
	"./en-IN/index.js": [
		46692,
		7,
		37748
	],
	"./en-IN/index.js.flow": [
		9857,
		7,
		90863
	],
	"./en-IN/package": [
		52063,
		3,
		52063
	],
	"./en-IN/package.json": [
		52063,
		3,
		52063
	],
	"./en-NZ": [
		70801,
		9,
		47469
	],
	"./en-NZ/": [
		70801,
		9,
		47469
	],
	"./en-NZ/_lib/formatLong": [
		5355,
		7,
		5355
	],
	"./en-NZ/_lib/formatLong/": [
		5355,
		7,
		5355
	],
	"./en-NZ/_lib/formatLong/index": [
		5355,
		7,
		5355
	],
	"./en-NZ/_lib/formatLong/index.js": [
		5355,
		7,
		5355
	],
	"./en-NZ/index": [
		61368,
		7,
		9028
	],
	"./en-NZ/index.d": [
		47469,
		9,
		47469
	],
	"./en-NZ/index.d.ts": [
		47469,
		9,
		47469
	],
	"./en-NZ/index.js": [
		61368,
		7,
		9028
	],
	"./en-NZ/index.js.flow": [
		87537,
		7,
		87537
	],
	"./en-NZ/package": [
		84177,
		3,
		84177
	],
	"./en-NZ/package.json": [
		84177,
		3,
		84177
	],
	"./en-US": [
		80337,
		9
	],
	"./en-US/": [
		80337,
		9
	],
	"./en-US/_lib/formatDistance": [
		50676,
		7,
		50676
	],
	"./en-US/_lib/formatDistance/": [
		50676,
		7,
		50676
	],
	"./en-US/_lib/formatDistance/index": [
		50676,
		7,
		50676
	],
	"./en-US/_lib/formatDistance/index.js": [
		50676,
		7,
		50676
	],
	"./en-US/_lib/formatLong": [
		21147,
		7,
		21147
	],
	"./en-US/_lib/formatLong/": [
		21147,
		7,
		21147
	],
	"./en-US/_lib/formatLong/index": [
		21147,
		7,
		21147
	],
	"./en-US/_lib/formatLong/index.js": [
		21147,
		7,
		21147
	],
	"./en-US/_lib/formatRelative": [
		54369,
		7,
		54369
	],
	"./en-US/_lib/formatRelative/": [
		54369,
		7,
		54369
	],
	"./en-US/_lib/formatRelative/index": [
		54369,
		7,
		54369
	],
	"./en-US/_lib/formatRelative/index.js": [
		54369,
		7,
		54369
	],
	"./en-US/_lib/localize": [
		73937,
		7,
		73937
	],
	"./en-US/_lib/localize/": [
		73937,
		7,
		73937
	],
	"./en-US/_lib/localize/index": [
		73937,
		7,
		73937
	],
	"./en-US/_lib/localize/index.js": [
		73937,
		7,
		73937
	],
	"./en-US/_lib/match": [
		35938,
		7,
		35938
	],
	"./en-US/_lib/match/": [
		35938,
		7,
		35938
	],
	"./en-US/_lib/match/index": [
		35938,
		7,
		35938
	],
	"./en-US/_lib/match/index.js": [
		35938,
		7,
		35938
	],
	"./en-US/index": [
		92670,
		7,
		9028
	],
	"./en-US/index.d": [
		73983,
		9,
		73983
	],
	"./en-US/index.d.ts": [
		73983,
		9,
		73983
	],
	"./en-US/index.js": [
		92670,
		7,
		9028
	],
	"./en-US/index.js.flow": [
		74515,
		7,
		74515
	],
	"./en-US/package": [
		89049,
		3,
		89049
	],
	"./en-US/package.json": [
		89049,
		3,
		89049
	],
	"./en-ZA": [
		73242,
		9,
		50062
	],
	"./en-ZA/": [
		73242,
		9,
		50062
	],
	"./en-ZA/_lib/formatLong": [
		80900,
		7,
		80900
	],
	"./en-ZA/_lib/formatLong/": [
		80900,
		7,
		80900
	],
	"./en-ZA/_lib/formatLong/index": [
		80900,
		7,
		80900
	],
	"./en-ZA/_lib/formatLong/index.js": [
		80900,
		7,
		80900
	],
	"./en-ZA/index": [
		3322,
		7,
		9028
	],
	"./en-ZA/index.d": [
		50062,
		9,
		50062
	],
	"./en-ZA/index.d.ts": [
		50062,
		9,
		50062
	],
	"./en-ZA/index.js": [
		3322,
		7,
		9028
	],
	"./en-ZA/index.js.flow": [
		12150,
		7,
		12150
	],
	"./en-ZA/package": [
		96657,
		3,
		96657
	],
	"./en-ZA/package.json": [
		96657,
		3,
		96657
	],
	"./eo": [
		11440,
		9,
		9091
	],
	"./eo/": [
		11440,
		9,
		9091
	],
	"./eo/_lib/formatDistance": [
		8201,
		7,
		8201
	],
	"./eo/_lib/formatDistance/": [
		8201,
		7,
		8201
	],
	"./eo/_lib/formatDistance/index": [
		8201,
		7,
		8201
	],
	"./eo/_lib/formatDistance/index.js": [
		8201,
		7,
		8201
	],
	"./eo/_lib/formatLong": [
		1084,
		7,
		1084
	],
	"./eo/_lib/formatLong/": [
		1084,
		7,
		1084
	],
	"./eo/_lib/formatLong/index": [
		1084,
		7,
		1084
	],
	"./eo/_lib/formatLong/index.js": [
		1084,
		7,
		1084
	],
	"./eo/_lib/formatRelative": [
		37412,
		7,
		37412
	],
	"./eo/_lib/formatRelative/": [
		37412,
		7,
		37412
	],
	"./eo/_lib/formatRelative/index": [
		37412,
		7,
		37412
	],
	"./eo/_lib/formatRelative/index.js": [
		37412,
		7,
		37412
	],
	"./eo/_lib/localize": [
		94318,
		7,
		94318
	],
	"./eo/_lib/localize/": [
		94318,
		7,
		94318
	],
	"./eo/_lib/localize/index": [
		94318,
		7,
		94318
	],
	"./eo/_lib/localize/index.js": [
		94318,
		7,
		94318
	],
	"./eo/_lib/match": [
		85254,
		7,
		85254
	],
	"./eo/_lib/match/": [
		85254,
		7,
		85254
	],
	"./eo/_lib/match/index": [
		85254,
		7,
		85254
	],
	"./eo/_lib/match/index.js": [
		85254,
		7,
		85254
	],
	"./eo/index": [
		55379,
		7,
		55379
	],
	"./eo/index.d": [
		9091,
		9,
		9091
	],
	"./eo/index.d.ts": [
		9091,
		9,
		9091
	],
	"./eo/index.js": [
		55379,
		7,
		55379
	],
	"./eo/index.js.flow": [
		54220,
		7,
		54220
	],
	"./eo/package": [
		4346,
		3,
		4346
	],
	"./eo/package.json": [
		4346,
		3,
		4346
	],
	"./es": [
		80148,
		9,
		92307
	],
	"./es/": [
		80148,
		9,
		92307
	],
	"./es/_lib/formatDistance": [
		86789,
		7,
		86789
	],
	"./es/_lib/formatDistance/": [
		86789,
		7,
		86789
	],
	"./es/_lib/formatDistance/index": [
		86789,
		7,
		86789
	],
	"./es/_lib/formatDistance/index.js": [
		86789,
		7,
		86789
	],
	"./es/_lib/formatLong": [
		90706,
		7,
		90706
	],
	"./es/_lib/formatLong/": [
		90706,
		7,
		90706
	],
	"./es/_lib/formatLong/index": [
		90706,
		7,
		90706
	],
	"./es/_lib/formatLong/index.js": [
		90706,
		7,
		90706
	],
	"./es/_lib/formatRelative": [
		90162,
		7,
		90162
	],
	"./es/_lib/formatRelative/": [
		90162,
		7,
		90162
	],
	"./es/_lib/formatRelative/index": [
		90162,
		7,
		90162
	],
	"./es/_lib/formatRelative/index.js": [
		90162,
		7,
		90162
	],
	"./es/_lib/localize": [
		79262,
		7,
		79262
	],
	"./es/_lib/localize/": [
		79262,
		7,
		79262
	],
	"./es/_lib/localize/index": [
		79262,
		7,
		79262
	],
	"./es/_lib/localize/index.js": [
		79262,
		7,
		79262
	],
	"./es/_lib/match": [
		58551,
		7,
		58551
	],
	"./es/_lib/match/": [
		58551,
		7,
		58551
	],
	"./es/_lib/match/index": [
		58551,
		7,
		58551
	],
	"./es/_lib/match/index.js": [
		58551,
		7,
		58551
	],
	"./es/index": [
		32569,
		7,
		32569
	],
	"./es/index.d": [
		92307,
		9,
		92307
	],
	"./es/index.d.ts": [
		92307,
		9,
		92307
	],
	"./es/index.js": [
		32569,
		7,
		32569
	],
	"./es/index.js.flow": [
		50427,
		7,
		50427
	],
	"./es/package": [
		291,
		3,
		280
	],
	"./es/package.json": [
		291,
		3,
		280
	],
	"./et": [
		64802,
		9,
		84647
	],
	"./et/": [
		64802,
		9,
		84647
	],
	"./et/_lib/formatDistance": [
		85139,
		7,
		85139
	],
	"./et/_lib/formatDistance/": [
		85139,
		7,
		85139
	],
	"./et/_lib/formatDistance/index": [
		85139,
		7,
		85139
	],
	"./et/_lib/formatDistance/index.js": [
		85139,
		7,
		85139
	],
	"./et/_lib/formatLong": [
		50835,
		7,
		50835
	],
	"./et/_lib/formatLong/": [
		50835,
		7,
		50835
	],
	"./et/_lib/formatLong/index": [
		50835,
		7,
		50835
	],
	"./et/_lib/formatLong/index.js": [
		50835,
		7,
		50835
	],
	"./et/_lib/formatRelative": [
		15428,
		7,
		15428
	],
	"./et/_lib/formatRelative/": [
		15428,
		7,
		15428
	],
	"./et/_lib/formatRelative/index": [
		15428,
		7,
		15428
	],
	"./et/_lib/formatRelative/index.js": [
		15428,
		7,
		15428
	],
	"./et/_lib/localize": [
		75646,
		7,
		75646
	],
	"./et/_lib/localize/": [
		75646,
		7,
		75646
	],
	"./et/_lib/localize/index": [
		75646,
		7,
		75646
	],
	"./et/_lib/localize/index.js": [
		75646,
		7,
		75646
	],
	"./et/_lib/match": [
		2549,
		7,
		2549
	],
	"./et/_lib/match/": [
		2549,
		7,
		2549
	],
	"./et/_lib/match/index": [
		2549,
		7,
		2549
	],
	"./et/_lib/match/index.js": [
		2549,
		7,
		2549
	],
	"./et/index": [
		97460,
		7,
		97460
	],
	"./et/index.d": [
		84647,
		9,
		84647
	],
	"./et/index.d.ts": [
		84647,
		9,
		84647
	],
	"./et/index.js": [
		97460,
		7,
		97460
	],
	"./et/index.js.flow": [
		20909,
		7,
		20909
	],
	"./et/package": [
		88581,
		3,
		88581
	],
	"./et/package.json": [
		88581,
		3,
		88581
	],
	"./eu": [
		26618,
		9,
		72599
	],
	"./eu/": [
		26618,
		9,
		72599
	],
	"./eu/_lib/formatDistance": [
		79146,
		7,
		79146
	],
	"./eu/_lib/formatDistance/": [
		79146,
		7,
		79146
	],
	"./eu/_lib/formatDistance/index": [
		79146,
		7,
		79146
	],
	"./eu/_lib/formatDistance/index.js": [
		79146,
		7,
		79146
	],
	"./eu/_lib/formatLong": [
		68961,
		7,
		68961
	],
	"./eu/_lib/formatLong/": [
		68961,
		7,
		68961
	],
	"./eu/_lib/formatLong/index": [
		68961,
		7,
		68961
	],
	"./eu/_lib/formatLong/index.js": [
		68961,
		7,
		68961
	],
	"./eu/_lib/formatRelative": [
		34229,
		7,
		34229
	],
	"./eu/_lib/formatRelative/": [
		34229,
		7,
		34229
	],
	"./eu/_lib/formatRelative/index": [
		34229,
		7,
		34229
	],
	"./eu/_lib/formatRelative/index.js": [
		34229,
		7,
		34229
	],
	"./eu/_lib/localize": [
		81566,
		7,
		81566
	],
	"./eu/_lib/localize/": [
		81566,
		7,
		81566
	],
	"./eu/_lib/localize/index": [
		81566,
		7,
		81566
	],
	"./eu/_lib/localize/index.js": [
		81566,
		7,
		81566
	],
	"./eu/_lib/match": [
		26058,
		7,
		26058
	],
	"./eu/_lib/match/": [
		26058,
		7,
		26058
	],
	"./eu/_lib/match/index": [
		26058,
		7,
		26058
	],
	"./eu/_lib/match/index.js": [
		26058,
		7,
		26058
	],
	"./eu/index": [
		21376,
		7,
		21376
	],
	"./eu/index.d": [
		72599,
		9,
		72599
	],
	"./eu/index.d.ts": [
		72599,
		9,
		72599
	],
	"./eu/index.js": [
		21376,
		7,
		21376
	],
	"./eu/index.js.flow": [
		18574,
		7,
		18574
	],
	"./eu/package": [
		72634,
		3,
		72634
	],
	"./eu/package.json": [
		72634,
		3,
		72634
	],
	"./fa-IR": [
		65848,
		9,
		21339
	],
	"./fa-IR/": [
		65848,
		9,
		21339
	],
	"./fa-IR/_lib/formatDistance": [
		76055,
		7,
		76055
	],
	"./fa-IR/_lib/formatDistance/": [
		76055,
		7,
		76055
	],
	"./fa-IR/_lib/formatDistance/index": [
		76055,
		7,
		76055
	],
	"./fa-IR/_lib/formatDistance/index.js": [
		76055,
		7,
		76055
	],
	"./fa-IR/_lib/formatLong": [
		38569,
		7,
		38569
	],
	"./fa-IR/_lib/formatLong/": [
		38569,
		7,
		38569
	],
	"./fa-IR/_lib/formatLong/index": [
		38569,
		7,
		38569
	],
	"./fa-IR/_lib/formatLong/index.js": [
		38569,
		7,
		38569
	],
	"./fa-IR/_lib/formatRelative": [
		85947,
		7,
		85947
	],
	"./fa-IR/_lib/formatRelative/": [
		85947,
		7,
		85947
	],
	"./fa-IR/_lib/formatRelative/index": [
		85947,
		7,
		85947
	],
	"./fa-IR/_lib/formatRelative/index.js": [
		85947,
		7,
		85947
	],
	"./fa-IR/_lib/localize": [
		7551,
		7,
		7551
	],
	"./fa-IR/_lib/localize/": [
		7551,
		7,
		7551
	],
	"./fa-IR/_lib/localize/index": [
		7551,
		7,
		7551
	],
	"./fa-IR/_lib/localize/index.js": [
		7551,
		7,
		7551
	],
	"./fa-IR/_lib/match": [
		47894,
		7,
		47894
	],
	"./fa-IR/_lib/match/": [
		47894,
		7,
		47894
	],
	"./fa-IR/_lib/match/index": [
		47894,
		7,
		47894
	],
	"./fa-IR/_lib/match/index.js": [
		47894,
		7,
		47894
	],
	"./fa-IR/index": [
		90538,
		7,
		90538
	],
	"./fa-IR/index.d": [
		21339,
		9,
		21339
	],
	"./fa-IR/index.d.ts": [
		21339,
		9,
		21339
	],
	"./fa-IR/index.js": [
		90538,
		7,
		90538
	],
	"./fa-IR/index.js.flow": [
		33597,
		7,
		33597
	],
	"./fa-IR/package": [
		83136,
		3,
		83136
	],
	"./fa-IR/package.json": [
		83136,
		3,
		83136
	],
	"./fi": [
		82245,
		9,
		15766
	],
	"./fi/": [
		82245,
		9,
		15766
	],
	"./fi/_lib/formatDistance": [
		3432,
		7,
		3432
	],
	"./fi/_lib/formatDistance/": [
		3432,
		7,
		3432
	],
	"./fi/_lib/formatDistance/index": [
		3432,
		7,
		3432
	],
	"./fi/_lib/formatDistance/index.js": [
		3432,
		7,
		3432
	],
	"./fi/_lib/formatLong": [
		69059,
		7,
		69059
	],
	"./fi/_lib/formatLong/": [
		69059,
		7,
		69059
	],
	"./fi/_lib/formatLong/index": [
		69059,
		7,
		69059
	],
	"./fi/_lib/formatLong/index.js": [
		69059,
		7,
		69059
	],
	"./fi/_lib/formatRelative": [
		38099,
		7,
		38099
	],
	"./fi/_lib/formatRelative/": [
		38099,
		7,
		38099
	],
	"./fi/_lib/formatRelative/index": [
		38099,
		7,
		38099
	],
	"./fi/_lib/formatRelative/index.js": [
		38099,
		7,
		38099
	],
	"./fi/_lib/localize": [
		83824,
		7,
		83824
	],
	"./fi/_lib/localize/": [
		83824,
		7,
		83824
	],
	"./fi/_lib/localize/index": [
		83824,
		7,
		83824
	],
	"./fi/_lib/localize/index.js": [
		83824,
		7,
		83824
	],
	"./fi/_lib/match": [
		49106,
		7,
		49106
	],
	"./fi/_lib/match/": [
		49106,
		7,
		49106
	],
	"./fi/_lib/match/index": [
		49106,
		7,
		49106
	],
	"./fi/_lib/match/index.js": [
		49106,
		7,
		49106
	],
	"./fi/index": [
		20336,
		7,
		20336
	],
	"./fi/index.d": [
		15766,
		9,
		15766
	],
	"./fi/index.d.ts": [
		15766,
		9,
		15766
	],
	"./fi/index.js": [
		20336,
		7,
		20336
	],
	"./fi/index.js.flow": [
		18343,
		7,
		18343
	],
	"./fi/package": [
		10482,
		3,
		10482
	],
	"./fi/package.json": [
		10482,
		3,
		10482
	],
	"./fr": [
		61754,
		9,
		58057
	],
	"./fr-CA": [
		63882,
		9,
		58057
	],
	"./fr-CA/": [
		63882,
		9,
		58057
	],
	"./fr-CA/_lib/formatLong": [
		48021,
		7,
		48021
	],
	"./fr-CA/_lib/formatLong/": [
		48021,
		7,
		48021
	],
	"./fr-CA/_lib/formatLong/index": [
		48021,
		7,
		48021
	],
	"./fr-CA/_lib/formatLong/index.js": [
		48021,
		7,
		48021
	],
	"./fr-CA/index": [
		51118,
		7,
		14051
	],
	"./fr-CA/index.d": [
		31124,
		9,
		58057
	],
	"./fr-CA/index.d.ts": [
		31124,
		9,
		58057
	],
	"./fr-CA/index.js": [
		51118,
		7,
		14051
	],
	"./fr-CA/index.js.flow": [
		86743,
		7,
		86743
	],
	"./fr-CA/package": [
		29653,
		3,
		29653
	],
	"./fr-CA/package.json": [
		29653,
		3,
		29653
	],
	"./fr-CH": [
		58513,
		9,
		58057
	],
	"./fr-CH/": [
		58513,
		9,
		58057
	],
	"./fr-CH/_lib/formatLong": [
		92076,
		7,
		92076
	],
	"./fr-CH/_lib/formatLong/": [
		92076,
		7,
		92076
	],
	"./fr-CH/_lib/formatLong/index": [
		92076,
		7,
		92076
	],
	"./fr-CH/_lib/formatLong/index.js": [
		92076,
		7,
		92076
	],
	"./fr-CH/_lib/formatRelative": [
		6183,
		7,
		6183
	],
	"./fr-CH/_lib/formatRelative/": [
		6183,
		7,
		6183
	],
	"./fr-CH/_lib/formatRelative/index": [
		6183,
		7,
		6183
	],
	"./fr-CH/_lib/formatRelative/index.js": [
		6183,
		7,
		6183
	],
	"./fr-CH/index": [
		67366,
		7,
		14051
	],
	"./fr-CH/index.d": [
		71281,
		9,
		58057
	],
	"./fr-CH/index.d.ts": [
		71281,
		9,
		58057
	],
	"./fr-CH/index.js": [
		67366,
		7,
		14051
	],
	"./fr-CH/index.js.flow": [
		9571,
		7,
		9571
	],
	"./fr-CH/package": [
		43141,
		3,
		43141
	],
	"./fr-CH/package.json": [
		43141,
		3,
		43141
	],
	"./fr/": [
		61754,
		9,
		58057
	],
	"./fr/_lib/formatDistance": [
		34378,
		7,
		34378
	],
	"./fr/_lib/formatDistance/": [
		34378,
		7,
		34378
	],
	"./fr/_lib/formatDistance/index": [
		34378,
		7,
		34378
	],
	"./fr/_lib/formatDistance/index.js": [
		34378,
		7,
		34378
	],
	"./fr/_lib/formatLong": [
		9517,
		7,
		9517
	],
	"./fr/_lib/formatLong/": [
		9517,
		7,
		9517
	],
	"./fr/_lib/formatLong/index": [
		9517,
		7,
		9517
	],
	"./fr/_lib/formatLong/index.js": [
		9517,
		7,
		9517
	],
	"./fr/_lib/formatRelative": [
		70737,
		7,
		70737
	],
	"./fr/_lib/formatRelative/": [
		70737,
		7,
		70737
	],
	"./fr/_lib/formatRelative/index": [
		70737,
		7,
		70737
	],
	"./fr/_lib/formatRelative/index.js": [
		70737,
		7,
		70737
	],
	"./fr/_lib/localize": [
		53786,
		7,
		53786
	],
	"./fr/_lib/localize/": [
		53786,
		7,
		53786
	],
	"./fr/_lib/localize/index": [
		53786,
		7,
		53786
	],
	"./fr/_lib/localize/index.js": [
		53786,
		7,
		53786
	],
	"./fr/_lib/match": [
		76935,
		7,
		76935
	],
	"./fr/_lib/match/": [
		76935,
		7,
		76935
	],
	"./fr/_lib/match/index": [
		76935,
		7,
		76935
	],
	"./fr/_lib/match/index.js": [
		76935,
		7,
		76935
	],
	"./fr/index": [
		47472,
		7,
		14051
	],
	"./fr/index.d": [
		84160,
		9,
		58057
	],
	"./fr/index.d.ts": [
		84160,
		9,
		58057
	],
	"./fr/index.js": [
		47472,
		7,
		14051
	],
	"./fr/index.js.flow": [
		41628,
		7,
		41628
	],
	"./fr/package": [
		80704,
		3,
		80704
	],
	"./fr/package.json": [
		80704,
		3,
		80704
	],
	"./fy": [
		86159,
		9,
		93014
	],
	"./fy/": [
		86159,
		9,
		93014
	],
	"./fy/_lib/formatDistance": [
		71230,
		7,
		71230
	],
	"./fy/_lib/formatDistance/": [
		71230,
		7,
		71230
	],
	"./fy/_lib/formatDistance/index": [
		71230,
		7,
		71230
	],
	"./fy/_lib/formatDistance/index.js": [
		71230,
		7,
		71230
	],
	"./fy/_lib/formatLong": [
		75128,
		7,
		75128
	],
	"./fy/_lib/formatLong/": [
		75128,
		7,
		75128
	],
	"./fy/_lib/formatLong/index": [
		75128,
		7,
		75128
	],
	"./fy/_lib/formatLong/index.js": [
		75128,
		7,
		75128
	],
	"./fy/_lib/formatRelative": [
		18280,
		7,
		18280
	],
	"./fy/_lib/formatRelative/": [
		18280,
		7,
		18280
	],
	"./fy/_lib/formatRelative/index": [
		18280,
		7,
		18280
	],
	"./fy/_lib/formatRelative/index.js": [
		18280,
		7,
		18280
	],
	"./fy/_lib/localize": [
		1266,
		7,
		1266
	],
	"./fy/_lib/localize/": [
		1266,
		7,
		1266
	],
	"./fy/_lib/localize/index": [
		1266,
		7,
		1266
	],
	"./fy/_lib/localize/index.js": [
		1266,
		7,
		1266
	],
	"./fy/_lib/match": [
		75449,
		7,
		75449
	],
	"./fy/_lib/match/": [
		75449,
		7,
		75449
	],
	"./fy/_lib/match/index": [
		75449,
		7,
		75449
	],
	"./fy/_lib/match/index.js": [
		75449,
		7,
		75449
	],
	"./fy/index": [
		94890,
		7,
		94890
	],
	"./fy/index.d": [
		93014,
		9,
		93014
	],
	"./fy/index.d.ts": [
		93014,
		9,
		93014
	],
	"./fy/index.js": [
		94890,
		7,
		94890
	],
	"./fy/index.js.flow": [
		55080,
		7,
		55080
	],
	"./fy/package": [
		64571,
		3,
		64571
	],
	"./fy/package.json": [
		64571,
		3,
		64571
	],
	"./gd": [
		45754,
		9,
		96103
	],
	"./gd/": [
		45754,
		9,
		96103
	],
	"./gd/_lib/formatDistance": [
		64275,
		7,
		64275
	],
	"./gd/_lib/formatDistance/": [
		64275,
		7,
		64275
	],
	"./gd/_lib/formatDistance/index": [
		64275,
		7,
		64275
	],
	"./gd/_lib/formatDistance/index.js": [
		64275,
		7,
		64275
	],
	"./gd/_lib/formatLong": [
		65960,
		7,
		65960
	],
	"./gd/_lib/formatLong/": [
		65960,
		7,
		65960
	],
	"./gd/_lib/formatLong/index": [
		65960,
		7,
		65960
	],
	"./gd/_lib/formatLong/index.js": [
		65960,
		7,
		65960
	],
	"./gd/_lib/formatRelative": [
		33221,
		7,
		33221
	],
	"./gd/_lib/formatRelative/": [
		33221,
		7,
		33221
	],
	"./gd/_lib/formatRelative/index": [
		33221,
		7,
		33221
	],
	"./gd/_lib/formatRelative/index.js": [
		33221,
		7,
		33221
	],
	"./gd/_lib/localize": [
		40338,
		7,
		40338
	],
	"./gd/_lib/localize/": [
		40338,
		7,
		40338
	],
	"./gd/_lib/localize/index": [
		40338,
		7,
		40338
	],
	"./gd/_lib/localize/index.js": [
		40338,
		7,
		40338
	],
	"./gd/_lib/match": [
		22138,
		7,
		22138
	],
	"./gd/_lib/match/": [
		22138,
		7,
		22138
	],
	"./gd/_lib/match/index": [
		22138,
		7,
		22138
	],
	"./gd/_lib/match/index.js": [
		22138,
		7,
		22138
	],
	"./gd/index": [
		37170,
		7,
		37170
	],
	"./gd/index.d": [
		96103,
		9,
		96103
	],
	"./gd/index.d.ts": [
		96103,
		9,
		96103
	],
	"./gd/index.js": [
		37170,
		7,
		37170
	],
	"./gd/index.js.flow": [
		14426,
		7,
		14426
	],
	"./gd/package": [
		50530,
		3,
		50530
	],
	"./gd/package.json": [
		50530,
		3,
		50530
	],
	"./gl": [
		10443,
		9,
		32330
	],
	"./gl/": [
		10443,
		9,
		32330
	],
	"./gl/_lib/formatDistance": [
		43150,
		7,
		43150
	],
	"./gl/_lib/formatDistance/": [
		43150,
		7,
		43150
	],
	"./gl/_lib/formatDistance/index": [
		43150,
		7,
		43150
	],
	"./gl/_lib/formatDistance/index.js": [
		43150,
		7,
		43150
	],
	"./gl/_lib/formatLong": [
		73001,
		7,
		73001
	],
	"./gl/_lib/formatLong/": [
		73001,
		7,
		73001
	],
	"./gl/_lib/formatLong/index": [
		73001,
		7,
		73001
	],
	"./gl/_lib/formatLong/index.js": [
		73001,
		7,
		73001
	],
	"./gl/_lib/formatRelative": [
		68227,
		7,
		68227
	],
	"./gl/_lib/formatRelative/": [
		68227,
		7,
		68227
	],
	"./gl/_lib/formatRelative/index": [
		68227,
		7,
		68227
	],
	"./gl/_lib/formatRelative/index.js": [
		68227,
		7,
		68227
	],
	"./gl/_lib/localize": [
		96081,
		7,
		96081
	],
	"./gl/_lib/localize/": [
		96081,
		7,
		96081
	],
	"./gl/_lib/localize/index": [
		96081,
		7,
		96081
	],
	"./gl/_lib/localize/index.js": [
		96081,
		7,
		96081
	],
	"./gl/_lib/match": [
		92303,
		7,
		92303
	],
	"./gl/_lib/match/": [
		92303,
		7,
		92303
	],
	"./gl/_lib/match/index": [
		92303,
		7,
		92303
	],
	"./gl/_lib/match/index.js": [
		92303,
		7,
		92303
	],
	"./gl/index": [
		41612,
		7,
		41612
	],
	"./gl/index.d": [
		32330,
		9,
		32330
	],
	"./gl/index.d.ts": [
		32330,
		9,
		32330
	],
	"./gl/index.js": [
		41612,
		7,
		41612
	],
	"./gl/index.js.flow": [
		93034,
		7,
		93034
	],
	"./gl/package": [
		28553,
		3,
		28553
	],
	"./gl/package.json": [
		28553,
		3,
		28553
	],
	"./gu": [
		24231,
		9,
		88857
	],
	"./gu/": [
		24231,
		9,
		88857
	],
	"./gu/_lib/formatDistance": [
		47305,
		7,
		47305
	],
	"./gu/_lib/formatDistance/": [
		47305,
		7,
		47305
	],
	"./gu/_lib/formatDistance/index": [
		47305,
		7,
		47305
	],
	"./gu/_lib/formatDistance/index.js": [
		47305,
		7,
		47305
	],
	"./gu/_lib/formatLong": [
		88408,
		7,
		88408
	],
	"./gu/_lib/formatLong/": [
		88408,
		7,
		88408
	],
	"./gu/_lib/formatLong/index": [
		88408,
		7,
		88408
	],
	"./gu/_lib/formatLong/index.js": [
		88408,
		7,
		88408
	],
	"./gu/_lib/formatRelative": [
		86422,
		7,
		86422
	],
	"./gu/_lib/formatRelative/": [
		86422,
		7,
		86422
	],
	"./gu/_lib/formatRelative/index": [
		86422,
		7,
		86422
	],
	"./gu/_lib/formatRelative/index.js": [
		86422,
		7,
		86422
	],
	"./gu/_lib/localize": [
		42826,
		7,
		42826
	],
	"./gu/_lib/localize/": [
		42826,
		7,
		42826
	],
	"./gu/_lib/localize/index": [
		42826,
		7,
		42826
	],
	"./gu/_lib/localize/index.js": [
		42826,
		7,
		42826
	],
	"./gu/_lib/match": [
		19011,
		7,
		19011
	],
	"./gu/_lib/match/": [
		19011,
		7,
		19011
	],
	"./gu/_lib/match/index": [
		19011,
		7,
		19011
	],
	"./gu/_lib/match/index.js": [
		19011,
		7,
		19011
	],
	"./gu/index": [
		90471,
		7,
		90471
	],
	"./gu/index.d": [
		88857,
		9,
		88857
	],
	"./gu/index.d.ts": [
		88857,
		9,
		88857
	],
	"./gu/index.js": [
		90471,
		7,
		90471
	],
	"./gu/index.js.flow": [
		7606,
		7,
		7606
	],
	"./gu/package": [
		20152,
		3,
		20152
	],
	"./gu/package.json": [
		20152,
		3,
		20152
	],
	"./he": [
		2772,
		9,
		84799
	],
	"./he/": [
		2772,
		9,
		84799
	],
	"./he/_lib/formatDistance": [
		6136,
		7,
		6136
	],
	"./he/_lib/formatDistance/": [
		6136,
		7,
		6136
	],
	"./he/_lib/formatDistance/index": [
		6136,
		7,
		6136
	],
	"./he/_lib/formatDistance/index.js": [
		6136,
		7,
		6136
	],
	"./he/_lib/formatLong": [
		92006,
		7,
		92006
	],
	"./he/_lib/formatLong/": [
		92006,
		7,
		92006
	],
	"./he/_lib/formatLong/index": [
		92006,
		7,
		92006
	],
	"./he/_lib/formatLong/index.js": [
		92006,
		7,
		92006
	],
	"./he/_lib/formatRelative": [
		1491,
		7,
		1491
	],
	"./he/_lib/formatRelative/": [
		1491,
		7,
		1491
	],
	"./he/_lib/formatRelative/index": [
		1491,
		7,
		1491
	],
	"./he/_lib/formatRelative/index.js": [
		1491,
		7,
		1491
	],
	"./he/_lib/localize": [
		11380,
		7,
		11380
	],
	"./he/_lib/localize/": [
		11380,
		7,
		11380
	],
	"./he/_lib/localize/index": [
		11380,
		7,
		11380
	],
	"./he/_lib/localize/index.js": [
		11380,
		7,
		11380
	],
	"./he/_lib/match": [
		83543,
		7,
		83543
	],
	"./he/_lib/match/": [
		83543,
		7,
		83543
	],
	"./he/_lib/match/index": [
		83543,
		7,
		83543
	],
	"./he/_lib/match/index.js": [
		83543,
		7,
		83543
	],
	"./he/index": [
		26399,
		7,
		26399
	],
	"./he/index.d": [
		84799,
		9,
		84799
	],
	"./he/index.d.ts": [
		84799,
		9,
		84799
	],
	"./he/index.js": [
		26399,
		7,
		26399
	],
	"./he/index.js.flow": [
		95632,
		7,
		95632
	],
	"./he/package": [
		68373,
		3,
		68373
	],
	"./he/package.json": [
		68373,
		3,
		68373
	],
	"./hi": [
		52761,
		9,
		56445
	],
	"./hi/": [
		52761,
		9,
		56445
	],
	"./hi/_lib/formatDistance": [
		28904,
		7,
		28904
	],
	"./hi/_lib/formatDistance/": [
		28904,
		7,
		28904
	],
	"./hi/_lib/formatDistance/index": [
		28904,
		7,
		28904
	],
	"./hi/_lib/formatDistance/index.js": [
		28904,
		7,
		28904
	],
	"./hi/_lib/formatLong": [
		3930,
		7,
		3930
	],
	"./hi/_lib/formatLong/": [
		3930,
		7,
		3930
	],
	"./hi/_lib/formatLong/index": [
		3930,
		7,
		3930
	],
	"./hi/_lib/formatLong/index.js": [
		3930,
		7,
		3930
	],
	"./hi/_lib/formatRelative": [
		45575,
		7,
		45575
	],
	"./hi/_lib/formatRelative/": [
		45575,
		7,
		45575
	],
	"./hi/_lib/formatRelative/index": [
		45575,
		7,
		45575
	],
	"./hi/_lib/formatRelative/index.js": [
		45575,
		7,
		45575
	],
	"./hi/_lib/localize": [
		12513,
		7,
		28904
	],
	"./hi/_lib/localize/": [
		12513,
		7,
		28904
	],
	"./hi/_lib/localize/index": [
		12513,
		7,
		28904
	],
	"./hi/_lib/localize/index.js": [
		12513,
		7,
		28904
	],
	"./hi/_lib/match": [
		91838,
		7,
		68779
	],
	"./hi/_lib/match/": [
		91838,
		7,
		68779
	],
	"./hi/_lib/match/index": [
		91838,
		7,
		68779
	],
	"./hi/_lib/match/index.js": [
		91838,
		7,
		68779
	],
	"./hi/index": [
		68779,
		7,
		68779
	],
	"./hi/index.d": [
		56445,
		9,
		56445
	],
	"./hi/index.d.ts": [
		56445,
		9,
		56445
	],
	"./hi/index.js": [
		68779,
		7,
		68779
	],
	"./hi/index.js.flow": [
		81789,
		7,
		81789
	],
	"./hi/package": [
		81117,
		3,
		81117
	],
	"./hi/package.json": [
		81117,
		3,
		81117
	],
	"./hr": [
		38577,
		9,
		4414
	],
	"./hr/": [
		38577,
		9,
		4414
	],
	"./hr/_lib/formatDistance": [
		41701,
		7,
		41701
	],
	"./hr/_lib/formatDistance/": [
		41701,
		7,
		41701
	],
	"./hr/_lib/formatDistance/index": [
		41701,
		7,
		41701
	],
	"./hr/_lib/formatDistance/index.js": [
		41701,
		7,
		41701
	],
	"./hr/_lib/formatLong": [
		62946,
		7,
		62946
	],
	"./hr/_lib/formatLong/": [
		62946,
		7,
		62946
	],
	"./hr/_lib/formatLong/index": [
		62946,
		7,
		62946
	],
	"./hr/_lib/formatLong/index.js": [
		62946,
		7,
		62946
	],
	"./hr/_lib/formatRelative": [
		10893,
		7,
		10893
	],
	"./hr/_lib/formatRelative/": [
		10893,
		7,
		10893
	],
	"./hr/_lib/formatRelative/index": [
		10893,
		7,
		10893
	],
	"./hr/_lib/formatRelative/index.js": [
		10893,
		7,
		10893
	],
	"./hr/_lib/localize": [
		89238,
		7,
		89238
	],
	"./hr/_lib/localize/": [
		89238,
		7,
		89238
	],
	"./hr/_lib/localize/index": [
		89238,
		7,
		89238
	],
	"./hr/_lib/localize/index.js": [
		89238,
		7,
		89238
	],
	"./hr/_lib/match": [
		38572,
		7,
		38572
	],
	"./hr/_lib/match/": [
		38572,
		7,
		38572
	],
	"./hr/_lib/match/index": [
		38572,
		7,
		38572
	],
	"./hr/_lib/match/index.js": [
		38572,
		7,
		38572
	],
	"./hr/index": [
		69902,
		7,
		69902
	],
	"./hr/index.d": [
		4414,
		9,
		4414
	],
	"./hr/index.d.ts": [
		4414,
		9,
		4414
	],
	"./hr/index.js": [
		69902,
		7,
		69902
	],
	"./hr/index.js.flow": [
		67352,
		7,
		67352
	],
	"./hr/package": [
		1813,
		3,
		1813
	],
	"./hr/package.json": [
		1813,
		3,
		1813
	],
	"./ht": [
		56010,
		9,
		85096
	],
	"./ht/": [
		56010,
		9,
		85096
	],
	"./ht/_lib/formatDistance": [
		30787,
		7,
		30787
	],
	"./ht/_lib/formatDistance/": [
		30787,
		7,
		30787
	],
	"./ht/_lib/formatDistance/index": [
		30787,
		7,
		30787
	],
	"./ht/_lib/formatDistance/index.js": [
		30787,
		7,
		30787
	],
	"./ht/_lib/formatLong": [
		55843,
		7,
		55843
	],
	"./ht/_lib/formatLong/": [
		55843,
		7,
		55843
	],
	"./ht/_lib/formatLong/index": [
		55843,
		7,
		55843
	],
	"./ht/_lib/formatLong/index.js": [
		55843,
		7,
		55843
	],
	"./ht/_lib/formatRelative": [
		80120,
		7,
		80120
	],
	"./ht/_lib/formatRelative/": [
		80120,
		7,
		80120
	],
	"./ht/_lib/formatRelative/index": [
		80120,
		7,
		80120
	],
	"./ht/_lib/formatRelative/index.js": [
		80120,
		7,
		80120
	],
	"./ht/_lib/localize": [
		54317,
		7,
		54317
	],
	"./ht/_lib/localize/": [
		54317,
		7,
		54317
	],
	"./ht/_lib/localize/index": [
		54317,
		7,
		54317
	],
	"./ht/_lib/localize/index.js": [
		54317,
		7,
		54317
	],
	"./ht/_lib/match": [
		21968,
		7,
		21968
	],
	"./ht/_lib/match/": [
		21968,
		7,
		21968
	],
	"./ht/_lib/match/index": [
		21968,
		7,
		21968
	],
	"./ht/_lib/match/index.js": [
		21968,
		7,
		21968
	],
	"./ht/index": [
		70684,
		7,
		70684
	],
	"./ht/index.d": [
		85096,
		9,
		85096
	],
	"./ht/index.d.ts": [
		85096,
		9,
		85096
	],
	"./ht/index.js": [
		70684,
		7,
		70684
	],
	"./ht/index.js.flow": [
		82285,
		7,
		82285
	],
	"./ht/package": [
		17188,
		3,
		17188
	],
	"./ht/package.json": [
		17188,
		3,
		17188
	],
	"./hu": [
		99255,
		9,
		21445
	],
	"./hu/": [
		99255,
		9,
		21445
	],
	"./hu/_lib/formatDistance": [
		53723,
		7,
		53723
	],
	"./hu/_lib/formatDistance/": [
		53723,
		7,
		53723
	],
	"./hu/_lib/formatDistance/index": [
		53723,
		7,
		53723
	],
	"./hu/_lib/formatDistance/index.js": [
		53723,
		7,
		53723
	],
	"./hu/_lib/formatLong": [
		70876,
		7,
		70876
	],
	"./hu/_lib/formatLong/": [
		70876,
		7,
		70876
	],
	"./hu/_lib/formatLong/index": [
		70876,
		7,
		70876
	],
	"./hu/_lib/formatLong/index.js": [
		70876,
		7,
		70876
	],
	"./hu/_lib/formatRelative": [
		18995,
		7,
		18995
	],
	"./hu/_lib/formatRelative/": [
		18995,
		7,
		18995
	],
	"./hu/_lib/formatRelative/index": [
		18995,
		7,
		18995
	],
	"./hu/_lib/formatRelative/index.js": [
		18995,
		7,
		18995
	],
	"./hu/_lib/localize": [
		69674,
		7,
		69674
	],
	"./hu/_lib/localize/": [
		69674,
		7,
		69674
	],
	"./hu/_lib/localize/index": [
		69674,
		7,
		69674
	],
	"./hu/_lib/localize/index.js": [
		69674,
		7,
		69674
	],
	"./hu/_lib/match": [
		35454,
		7,
		35454
	],
	"./hu/_lib/match/": [
		35454,
		7,
		35454
	],
	"./hu/_lib/match/index": [
		35454,
		7,
		35454
	],
	"./hu/_lib/match/index.js": [
		35454,
		7,
		35454
	],
	"./hu/index": [
		16301,
		7,
		16301
	],
	"./hu/index.d": [
		21445,
		9,
		21445
	],
	"./hu/index.d.ts": [
		21445,
		9,
		21445
	],
	"./hu/index.js": [
		16301,
		7,
		16301
	],
	"./hu/index.js.flow": [
		99348,
		7,
		99348
	],
	"./hu/package": [
		3630,
		3,
		3630
	],
	"./hu/package.json": [
		3630,
		3,
		3630
	],
	"./hy": [
		42118,
		9,
		1364
	],
	"./hy/": [
		42118,
		9,
		1364
	],
	"./hy/_lib/formatDistance": [
		13820,
		7,
		13820
	],
	"./hy/_lib/formatDistance/": [
		13820,
		7,
		13820
	],
	"./hy/_lib/formatDistance/index": [
		13820,
		7,
		13820
	],
	"./hy/_lib/formatDistance/index.js": [
		13820,
		7,
		13820
	],
	"./hy/_lib/formatLong": [
		20008,
		7,
		20008
	],
	"./hy/_lib/formatLong/": [
		20008,
		7,
		20008
	],
	"./hy/_lib/formatLong/index": [
		20008,
		7,
		20008
	],
	"./hy/_lib/formatLong/index.js": [
		20008,
		7,
		20008
	],
	"./hy/_lib/formatRelative": [
		46792,
		7,
		46792
	],
	"./hy/_lib/formatRelative/": [
		46792,
		7,
		46792
	],
	"./hy/_lib/formatRelative/index": [
		46792,
		7,
		46792
	],
	"./hy/_lib/formatRelative/index.js": [
		46792,
		7,
		46792
	],
	"./hy/_lib/localize": [
		78809,
		7,
		78809
	],
	"./hy/_lib/localize/": [
		78809,
		7,
		78809
	],
	"./hy/_lib/localize/index": [
		78809,
		7,
		78809
	],
	"./hy/_lib/localize/index.js": [
		78809,
		7,
		78809
	],
	"./hy/_lib/match": [
		88780,
		7,
		88780
	],
	"./hy/_lib/match/": [
		88780,
		7,
		88780
	],
	"./hy/_lib/match/index": [
		88780,
		7,
		88780
	],
	"./hy/_lib/match/index.js": [
		88780,
		7,
		88780
	],
	"./hy/index": [
		46750,
		7,
		46750
	],
	"./hy/index.d": [
		1364,
		9,
		1364
	],
	"./hy/index.d.ts": [
		1364,
		9,
		1364
	],
	"./hy/index.js": [
		46750,
		7,
		46750
	],
	"./hy/index.js.flow": [
		53666,
		7,
		53666
	],
	"./hy/package": [
		47638,
		3,
		47638
	],
	"./hy/package.json": [
		47638,
		3,
		47638
	],
	"./id": [
		70908,
		9,
		92029
	],
	"./id/": [
		70908,
		9,
		92029
	],
	"./id/_lib/formatDistance": [
		217,
		7,
		217
	],
	"./id/_lib/formatDistance/": [
		217,
		7,
		217
	],
	"./id/_lib/formatDistance/index": [
		217,
		7,
		217
	],
	"./id/_lib/formatDistance/index.js": [
		217,
		7,
		217
	],
	"./id/_lib/formatLong": [
		93436,
		7,
		93436
	],
	"./id/_lib/formatLong/": [
		93436,
		7,
		93436
	],
	"./id/_lib/formatLong/index": [
		93436,
		7,
		93436
	],
	"./id/_lib/formatLong/index.js": [
		93436,
		7,
		93436
	],
	"./id/_lib/formatRelative": [
		99925,
		7,
		99925
	],
	"./id/_lib/formatRelative/": [
		99925,
		7,
		99925
	],
	"./id/_lib/formatRelative/index": [
		99925,
		7,
		99925
	],
	"./id/_lib/formatRelative/index.js": [
		99925,
		7,
		99925
	],
	"./id/_lib/localize": [
		45108,
		7,
		45108
	],
	"./id/_lib/localize/": [
		45108,
		7,
		45108
	],
	"./id/_lib/localize/index": [
		45108,
		7,
		45108
	],
	"./id/_lib/localize/index.js": [
		45108,
		7,
		45108
	],
	"./id/_lib/match": [
		54598,
		7,
		54598
	],
	"./id/_lib/match/": [
		54598,
		7,
		54598
	],
	"./id/_lib/match/index": [
		54598,
		7,
		54598
	],
	"./id/_lib/match/index.js": [
		54598,
		7,
		54598
	],
	"./id/index": [
		8559,
		7,
		8559
	],
	"./id/index.d": [
		92029,
		9,
		92029
	],
	"./id/index.d.ts": [
		92029,
		9,
		92029
	],
	"./id/index.js": [
		8559,
		7,
		8559
	],
	"./id/index.js.flow": [
		63823,
		7,
		63823
	],
	"./id/package": [
		81037,
		3,
		81037
	],
	"./id/package.json": [
		81037,
		3,
		81037
	],
	"./index": [
		19856,
		7,
		19856
	],
	"./index.js": [
		19856,
		7,
		19856
	],
	"./index.js.flow": [
		73614,
		7,
		73614
	],
	"./is": [
		25540,
		9,
		14991
	],
	"./is/": [
		25540,
		9,
		14991
	],
	"./is/_lib/formatDistance": [
		13419,
		7,
		13419
	],
	"./is/_lib/formatDistance/": [
		13419,
		7,
		13419
	],
	"./is/_lib/formatDistance/index": [
		13419,
		7,
		13419
	],
	"./is/_lib/formatDistance/index.js": [
		13419,
		7,
		13419
	],
	"./is/_lib/formatLong": [
		74913,
		7,
		74913
	],
	"./is/_lib/formatLong/": [
		74913,
		7,
		74913
	],
	"./is/_lib/formatLong/index": [
		74913,
		7,
		74913
	],
	"./is/_lib/formatLong/index.js": [
		74913,
		7,
		74913
	],
	"./is/_lib/formatRelative": [
		93112,
		7,
		93112
	],
	"./is/_lib/formatRelative/": [
		93112,
		7,
		93112
	],
	"./is/_lib/formatRelative/index": [
		93112,
		7,
		93112
	],
	"./is/_lib/formatRelative/index.js": [
		93112,
		7,
		93112
	],
	"./is/_lib/localize": [
		58619,
		7,
		58619
	],
	"./is/_lib/localize/": [
		58619,
		7,
		58619
	],
	"./is/_lib/localize/index": [
		58619,
		7,
		58619
	],
	"./is/_lib/localize/index.js": [
		58619,
		7,
		58619
	],
	"./is/_lib/match": [
		3724,
		7,
		13404
	],
	"./is/_lib/match/": [
		3724,
		7,
		13404
	],
	"./is/_lib/match/index": [
		3724,
		7,
		13404
	],
	"./is/_lib/match/index.js": [
		3724,
		7,
		13404
	],
	"./is/index": [
		15695,
		7,
		15695
	],
	"./is/index.d": [
		14991,
		9,
		14991
	],
	"./is/index.d.ts": [
		14991,
		9,
		14991
	],
	"./is/index.js": [
		15695,
		7,
		15695
	],
	"./is/index.js.flow": [
		39206,
		7,
		39206
	],
	"./is/package": [
		71136,
		3,
		71136
	],
	"./is/package.json": [
		71136,
		3,
		71136
	],
	"./it": [
		5965,
		9,
		90392
	],
	"./it-CH": [
		15604,
		9,
		90392
	],
	"./it-CH/": [
		15604,
		9,
		90392
	],
	"./it-CH/_lib/formatLong": [
		26106,
		7,
		26106
	],
	"./it-CH/_lib/formatLong/": [
		26106,
		7,
		26106
	],
	"./it-CH/_lib/formatLong/index": [
		26106,
		7,
		26106
	],
	"./it-CH/_lib/formatLong/index.js": [
		26106,
		7,
		26106
	],
	"./it-CH/index": [
		63279,
		7,
		84167
	],
	"./it-CH/index.d": [
		42722,
		9,
		90392
	],
	"./it-CH/index.d.ts": [
		42722,
		9,
		90392
	],
	"./it-CH/index.js": [
		63279,
		7,
		84167
	],
	"./it-CH/index.js.flow": [
		32151,
		7,
		32151
	],
	"./it-CH/package": [
		24839,
		3,
		24839
	],
	"./it-CH/package.json": [
		24839,
		3,
		24839
	],
	"./it/": [
		5965,
		9,
		90392
	],
	"./it/_lib/formatDistance": [
		19285,
		7,
		19285
	],
	"./it/_lib/formatDistance/": [
		19285,
		7,
		19285
	],
	"./it/_lib/formatDistance/index": [
		19285,
		7,
		19285
	],
	"./it/_lib/formatDistance/index.js": [
		19285,
		7,
		19285
	],
	"./it/_lib/formatLong": [
		36302,
		7,
		36302
	],
	"./it/_lib/formatLong/": [
		36302,
		7,
		36302
	],
	"./it/_lib/formatLong/index": [
		36302,
		7,
		36302
	],
	"./it/_lib/formatLong/index.js": [
		36302,
		7,
		36302
	],
	"./it/_lib/formatRelative": [
		75994,
		7,
		5510
	],
	"./it/_lib/formatRelative/": [
		75994,
		7,
		5510
	],
	"./it/_lib/formatRelative/index": [
		75994,
		7,
		5510
	],
	"./it/_lib/formatRelative/index.js": [
		75994,
		7,
		5510
	],
	"./it/_lib/localize": [
		68973,
		7,
		68973
	],
	"./it/_lib/localize/": [
		68973,
		7,
		68973
	],
	"./it/_lib/localize/index": [
		68973,
		7,
		68973
	],
	"./it/_lib/localize/index.js": [
		68973,
		7,
		68973
	],
	"./it/_lib/match": [
		23495,
		7,
		23495
	],
	"./it/_lib/match/": [
		23495,
		7,
		23495
	],
	"./it/_lib/match/index": [
		23495,
		7,
		23495
	],
	"./it/_lib/match/index.js": [
		23495,
		7,
		23495
	],
	"./it/index": [
		20386,
		7,
		84167
	],
	"./it/index.d": [
		88906,
		9,
		90392
	],
	"./it/index.d.ts": [
		88906,
		9,
		90392
	],
	"./it/index.js": [
		20386,
		7,
		84167
	],
	"./it/index.js.flow": [
		13540,
		7,
		13540
	],
	"./it/package": [
		44570,
		3,
		44570
	],
	"./it/package.json": [
		44570,
		3,
		44570
	],
	"./ja": [
		22547,
		9,
		55834
	],
	"./ja-Hira": [
		44503,
		9,
		9440
	],
	"./ja-Hira/": [
		44503,
		9,
		9440
	],
	"./ja-Hira/_lib/formatDistance": [
		85526,
		7,
		85526
	],
	"./ja-Hira/_lib/formatDistance/": [
		85526,
		7,
		85526
	],
	"./ja-Hira/_lib/formatDistance/index": [
		85526,
		7,
		85526
	],
	"./ja-Hira/_lib/formatDistance/index.js": [
		85526,
		7,
		85526
	],
	"./ja-Hira/_lib/formatLong": [
		64207,
		7,
		64207
	],
	"./ja-Hira/_lib/formatLong/": [
		64207,
		7,
		64207
	],
	"./ja-Hira/_lib/formatLong/index": [
		64207,
		7,
		64207
	],
	"./ja-Hira/_lib/formatLong/index.js": [
		64207,
		7,
		64207
	],
	"./ja-Hira/_lib/formatRelative": [
		70105,
		7,
		70105
	],
	"./ja-Hira/_lib/formatRelative/": [
		70105,
		7,
		70105
	],
	"./ja-Hira/_lib/formatRelative/index": [
		70105,
		7,
		70105
	],
	"./ja-Hira/_lib/formatRelative/index.js": [
		70105,
		7,
		70105
	],
	"./ja-Hira/_lib/localize": [
		22450,
		7,
		22450
	],
	"./ja-Hira/_lib/localize/": [
		22450,
		7,
		22450
	],
	"./ja-Hira/_lib/localize/index": [
		22450,
		7,
		22450
	],
	"./ja-Hira/_lib/localize/index.js": [
		22450,
		7,
		22450
	],
	"./ja-Hira/_lib/match": [
		34627,
		7,
		34627
	],
	"./ja-Hira/_lib/match/": [
		34627,
		7,
		34627
	],
	"./ja-Hira/_lib/match/index": [
		34627,
		7,
		34627
	],
	"./ja-Hira/_lib/match/index.js": [
		34627,
		7,
		34627
	],
	"./ja-Hira/index": [
		17519,
		7,
		17519
	],
	"./ja-Hira/index.d": [
		9440,
		9,
		9440
	],
	"./ja-Hira/index.d.ts": [
		9440,
		9,
		9440
	],
	"./ja-Hira/index.js": [
		17519,
		7,
		17519
	],
	"./ja-Hira/index.js.flow": [
		9199,
		7,
		9199
	],
	"./ja-Hira/package": [
		7964,
		3,
		7964
	],
	"./ja-Hira/package.json": [
		7964,
		3,
		7964
	],
	"./ja/": [
		22547,
		9,
		55834
	],
	"./ja/_lib/formatDistance": [
		26438,
		7,
		26438
	],
	"./ja/_lib/formatDistance/": [
		26438,
		7,
		26438
	],
	"./ja/_lib/formatDistance/index": [
		26438,
		7,
		26438
	],
	"./ja/_lib/formatDistance/index.js": [
		26438,
		7,
		26438
	],
	"./ja/_lib/formatLong": [
		8666,
		7,
		8666
	],
	"./ja/_lib/formatLong/": [
		8666,
		7,
		8666
	],
	"./ja/_lib/formatLong/index": [
		8666,
		7,
		8666
	],
	"./ja/_lib/formatLong/index.js": [
		8666,
		7,
		8666
	],
	"./ja/_lib/formatRelative": [
		6673,
		7,
		6673
	],
	"./ja/_lib/formatRelative/": [
		6673,
		7,
		6673
	],
	"./ja/_lib/formatRelative/index": [
		6673,
		7,
		6673
	],
	"./ja/_lib/formatRelative/index.js": [
		6673,
		7,
		6673
	],
	"./ja/_lib/localize": [
		26469,
		7,
		26469
	],
	"./ja/_lib/localize/": [
		26469,
		7,
		26469
	],
	"./ja/_lib/localize/index": [
		26469,
		7,
		26469
	],
	"./ja/_lib/localize/index.js": [
		26469,
		7,
		26469
	],
	"./ja/_lib/match": [
		82099,
		7,
		82099
	],
	"./ja/_lib/match/": [
		82099,
		7,
		82099
	],
	"./ja/_lib/match/index": [
		82099,
		7,
		82099
	],
	"./ja/_lib/match/index.js": [
		82099,
		7,
		82099
	],
	"./ja/index": [
		58770,
		7,
		58770
	],
	"./ja/index.d": [
		55834,
		9,
		55834
	],
	"./ja/index.d.ts": [
		55834,
		9,
		55834
	],
	"./ja/index.js": [
		58770,
		7,
		58770
	],
	"./ja/index.js.flow": [
		9967,
		7,
		9967
	],
	"./ja/package": [
		89712,
		3,
		89712
	],
	"./ja/package.json": [
		89712,
		3,
		89712
	],
	"./ka": [
		35402,
		9,
		90655
	],
	"./ka/": [
		35402,
		9,
		90655
	],
	"./ka/_lib/formatDistance": [
		60571,
		7,
		60571
	],
	"./ka/_lib/formatDistance/": [
		60571,
		7,
		60571
	],
	"./ka/_lib/formatDistance/index": [
		60571,
		7,
		60571
	],
	"./ka/_lib/formatDistance/index.js": [
		60571,
		7,
		60571
	],
	"./ka/_lib/formatLong": [
		22939,
		7,
		22939
	],
	"./ka/_lib/formatLong/": [
		22939,
		7,
		22939
	],
	"./ka/_lib/formatLong/index": [
		22939,
		7,
		22939
	],
	"./ka/_lib/formatLong/index.js": [
		22939,
		7,
		22939
	],
	"./ka/_lib/formatRelative": [
		93370,
		7,
		93370
	],
	"./ka/_lib/formatRelative/": [
		93370,
		7,
		93370
	],
	"./ka/_lib/formatRelative/index": [
		93370,
		7,
		93370
	],
	"./ka/_lib/formatRelative/index.js": [
		93370,
		7,
		93370
	],
	"./ka/_lib/localize": [
		36326,
		7,
		36326
	],
	"./ka/_lib/localize/": [
		36326,
		7,
		36326
	],
	"./ka/_lib/localize/index": [
		36326,
		7,
		36326
	],
	"./ka/_lib/localize/index.js": [
		36326,
		7,
		36326
	],
	"./ka/_lib/match": [
		9078,
		7,
		9078
	],
	"./ka/_lib/match/": [
		9078,
		7,
		9078
	],
	"./ka/_lib/match/index": [
		9078,
		7,
		9078
	],
	"./ka/_lib/match/index.js": [
		9078,
		7,
		9078
	],
	"./ka/index": [
		35595,
		7,
		35595
	],
	"./ka/index.d": [
		90655,
		9,
		90655
	],
	"./ka/index.d.ts": [
		90655,
		9,
		90655
	],
	"./ka/index.js": [
		35595,
		7,
		35595
	],
	"./ka/index.js.flow": [
		33745,
		7,
		33745
	],
	"./ka/package": [
		90933,
		3,
		90933
	],
	"./ka/package.json": [
		90933,
		3,
		90933
	],
	"./kk": [
		82458,
		9,
		52581
	],
	"./kk/": [
		82458,
		9,
		52581
	],
	"./kk/_lib/formatDistance": [
		17681,
		7,
		17681
	],
	"./kk/_lib/formatDistance/": [
		17681,
		7,
		17681
	],
	"./kk/_lib/formatDistance/index": [
		17681,
		7,
		17681
	],
	"./kk/_lib/formatDistance/index.js": [
		17681,
		7,
		17681
	],
	"./kk/_lib/formatLong": [
		32186,
		7,
		32186
	],
	"./kk/_lib/formatLong/": [
		32186,
		7,
		32186
	],
	"./kk/_lib/formatLong/index": [
		32186,
		7,
		32186
	],
	"./kk/_lib/formatLong/index.js": [
		32186,
		7,
		32186
	],
	"./kk/_lib/formatRelative": [
		9615,
		7,
		5510
	],
	"./kk/_lib/formatRelative/": [
		9615,
		7,
		5510
	],
	"./kk/_lib/formatRelative/index": [
		9615,
		7,
		5510
	],
	"./kk/_lib/formatRelative/index.js": [
		9615,
		7,
		5510
	],
	"./kk/_lib/localize": [
		57111,
		7,
		57111
	],
	"./kk/_lib/localize/": [
		57111,
		7,
		57111
	],
	"./kk/_lib/localize/index": [
		57111,
		7,
		57111
	],
	"./kk/_lib/localize/index.js": [
		57111,
		7,
		57111
	],
	"./kk/_lib/match": [
		20105,
		7,
		20105
	],
	"./kk/_lib/match/": [
		20105,
		7,
		20105
	],
	"./kk/_lib/match/index": [
		20105,
		7,
		20105
	],
	"./kk/_lib/match/index.js": [
		20105,
		7,
		20105
	],
	"./kk/index": [
		49634,
		7,
		49634
	],
	"./kk/index.d": [
		52581,
		9,
		52581
	],
	"./kk/index.d.ts": [
		52581,
		9,
		52581
	],
	"./kk/index.js": [
		49634,
		7,
		49634
	],
	"./kk/index.js.flow": [
		15635,
		7,
		15635
	],
	"./kk/package": [
		37617,
		3,
		37617
	],
	"./kk/package.json": [
		37617,
		3,
		37617
	],
	"./km": [
		19520,
		9,
		10036
	],
	"./km/": [
		19520,
		9,
		10036
	],
	"./km/_lib/formatDistance": [
		33180,
		7,
		33180
	],
	"./km/_lib/formatDistance/": [
		33180,
		7,
		33180
	],
	"./km/_lib/formatDistance/index": [
		33180,
		7,
		33180
	],
	"./km/_lib/formatDistance/index.js": [
		33180,
		7,
		33180
	],
	"./km/_lib/formatLong": [
		84047,
		7,
		84047
	],
	"./km/_lib/formatLong/": [
		84047,
		7,
		84047
	],
	"./km/_lib/formatLong/index": [
		84047,
		7,
		84047
	],
	"./km/_lib/formatLong/index.js": [
		84047,
		7,
		84047
	],
	"./km/_lib/formatRelative": [
		64098,
		7,
		37840
	],
	"./km/_lib/formatRelative/": [
		64098,
		7,
		37840
	],
	"./km/_lib/formatRelative/index": [
		64098,
		7,
		37840
	],
	"./km/_lib/formatRelative/index.js": [
		64098,
		7,
		37840
	],
	"./km/_lib/localize": [
		71581,
		7,
		71581
	],
	"./km/_lib/localize/": [
		71581,
		7,
		71581
	],
	"./km/_lib/localize/index": [
		71581,
		7,
		71581
	],
	"./km/_lib/localize/index.js": [
		71581,
		7,
		71581
	],
	"./km/_lib/match": [
		87422,
		7,
		87422
	],
	"./km/_lib/match/": [
		87422,
		7,
		87422
	],
	"./km/_lib/match/index": [
		87422,
		7,
		87422
	],
	"./km/_lib/match/index.js": [
		87422,
		7,
		87422
	],
	"./km/index": [
		65846,
		7,
		65846
	],
	"./km/index.d": [
		10036,
		9,
		10036
	],
	"./km/index.d.ts": [
		10036,
		9,
		10036
	],
	"./km/index.js": [
		65846,
		7,
		65846
	],
	"./km/index.js.flow": [
		66381,
		7,
		66381
	],
	"./km/package": [
		98300,
		3,
		98300
	],
	"./km/package.json": [
		98300,
		3,
		98300
	],
	"./kn": [
		80575,
		9,
		71355
	],
	"./kn/": [
		80575,
		9,
		71355
	],
	"./kn/_lib/formatDistance": [
		58834,
		7,
		28737
	],
	"./kn/_lib/formatDistance/": [
		58834,
		7,
		28737
	],
	"./kn/_lib/formatDistance/index": [
		58834,
		7,
		28737
	],
	"./kn/_lib/formatDistance/index.js": [
		58834,
		7,
		28737
	],
	"./kn/_lib/formatLong": [
		5763,
		7,
		5763
	],
	"./kn/_lib/formatLong/": [
		5763,
		7,
		5763
	],
	"./kn/_lib/formatLong/index": [
		5763,
		7,
		5763
	],
	"./kn/_lib/formatLong/index.js": [
		5763,
		7,
		5763
	],
	"./kn/_lib/formatRelative": [
		11602,
		7,
		11602
	],
	"./kn/_lib/formatRelative/": [
		11602,
		7,
		11602
	],
	"./kn/_lib/formatRelative/index": [
		11602,
		7,
		11602
	],
	"./kn/_lib/formatRelative/index.js": [
		11602,
		7,
		11602
	],
	"./kn/_lib/localize": [
		83230,
		7,
		83230
	],
	"./kn/_lib/localize/": [
		83230,
		7,
		83230
	],
	"./kn/_lib/localize/index": [
		83230,
		7,
		83230
	],
	"./kn/_lib/localize/index.js": [
		83230,
		7,
		83230
	],
	"./kn/_lib/match": [
		48277,
		7,
		48277
	],
	"./kn/_lib/match/": [
		48277,
		7,
		48277
	],
	"./kn/_lib/match/index": [
		48277,
		7,
		48277
	],
	"./kn/_lib/match/index.js": [
		48277,
		7,
		48277
	],
	"./kn/index": [
		48833,
		7,
		48833
	],
	"./kn/index.d": [
		71355,
		9,
		71355
	],
	"./kn/index.d.ts": [
		71355,
		9,
		71355
	],
	"./kn/index.js": [
		48833,
		7,
		48833
	],
	"./kn/index.js.flow": [
		50880,
		7,
		50880
	],
	"./kn/package": [
		38942,
		3,
		38942
	],
	"./kn/package.json": [
		38942,
		3,
		38942
	],
	"./ko": [
		74246,
		9,
		71709
	],
	"./ko/": [
		74246,
		9,
		71709
	],
	"./ko/_lib/formatDistance": [
		62646,
		7,
		62646
	],
	"./ko/_lib/formatDistance/": [
		62646,
		7,
		62646
	],
	"./ko/_lib/formatDistance/index": [
		62646,
		7,
		62646
	],
	"./ko/_lib/formatDistance/index.js": [
		62646,
		7,
		62646
	],
	"./ko/_lib/formatLong": [
		95136,
		7,
		95136
	],
	"./ko/_lib/formatLong/": [
		95136,
		7,
		95136
	],
	"./ko/_lib/formatLong/index": [
		95136,
		7,
		95136
	],
	"./ko/_lib/formatLong/index.js": [
		95136,
		7,
		95136
	],
	"./ko/_lib/formatRelative": [
		71881,
		7,
		71881
	],
	"./ko/_lib/formatRelative/": [
		71881,
		7,
		71881
	],
	"./ko/_lib/formatRelative/index": [
		71881,
		7,
		71881
	],
	"./ko/_lib/formatRelative/index.js": [
		71881,
		7,
		71881
	],
	"./ko/_lib/localize": [
		47228,
		7,
		47228
	],
	"./ko/_lib/localize/": [
		47228,
		7,
		47228
	],
	"./ko/_lib/localize/index": [
		47228,
		7,
		47228
	],
	"./ko/_lib/localize/index.js": [
		47228,
		7,
		47228
	],
	"./ko/_lib/match": [
		69346,
		7,
		69346
	],
	"./ko/_lib/match/": [
		69346,
		7,
		69346
	],
	"./ko/_lib/match/index": [
		69346,
		7,
		69346
	],
	"./ko/_lib/match/index.js": [
		69346,
		7,
		69346
	],
	"./ko/index": [
		91189,
		7,
		66799
	],
	"./ko/index.d": [
		71709,
		9,
		71709
	],
	"./ko/index.d.ts": [
		71709,
		9,
		71709
	],
	"./ko/index.js": [
		91189,
		7,
		66799
	],
	"./ko/index.js.flow": [
		75341,
		7,
		75341
	],
	"./ko/package": [
		54065,
		3,
		54065
	],
	"./ko/package.json": [
		54065,
		3,
		54065
	],
	"./lb": [
		60125,
		9,
		44244
	],
	"./lb/": [
		60125,
		9,
		44244
	],
	"./lb/_lib/formatDistance": [
		19747,
		7,
		19747
	],
	"./lb/_lib/formatDistance/": [
		19747,
		7,
		19747
	],
	"./lb/_lib/formatDistance/index": [
		19747,
		7,
		19747
	],
	"./lb/_lib/formatDistance/index.js": [
		19747,
		7,
		19747
	],
	"./lb/_lib/formatLong": [
		38613,
		7,
		38613
	],
	"./lb/_lib/formatLong/": [
		38613,
		7,
		38613
	],
	"./lb/_lib/formatLong/index": [
		38613,
		7,
		38613
	],
	"./lb/_lib/formatLong/index.js": [
		38613,
		7,
		38613
	],
	"./lb/_lib/formatRelative": [
		77903,
		7,
		77903
	],
	"./lb/_lib/formatRelative/": [
		77903,
		7,
		77903
	],
	"./lb/_lib/formatRelative/index": [
		77903,
		7,
		77903
	],
	"./lb/_lib/formatRelative/index.js": [
		77903,
		7,
		77903
	],
	"./lb/_lib/localize": [
		94806,
		7,
		94806
	],
	"./lb/_lib/localize/": [
		94806,
		7,
		94806
	],
	"./lb/_lib/localize/index": [
		94806,
		7,
		94806
	],
	"./lb/_lib/localize/index.js": [
		94806,
		7,
		94806
	],
	"./lb/_lib/match": [
		78376,
		7,
		78376
	],
	"./lb/_lib/match/": [
		78376,
		7,
		78376
	],
	"./lb/_lib/match/index": [
		78376,
		7,
		78376
	],
	"./lb/_lib/match/index.js": [
		78376,
		7,
		78376
	],
	"./lb/index": [
		77562,
		7,
		77562
	],
	"./lb/index.d": [
		44244,
		9,
		44244
	],
	"./lb/index.d.ts": [
		44244,
		9,
		44244
	],
	"./lb/index.js": [
		77562,
		7,
		77562
	],
	"./lb/index.js.flow": [
		93189,
		7,
		93189
	],
	"./lb/package": [
		63604,
		3,
		63604
	],
	"./lb/package.json": [
		63604,
		3,
		63604
	],
	"./lt": [
		16856,
		9,
		45534
	],
	"./lt/": [
		16856,
		9,
		45534
	],
	"./lt/_lib/formatDistance": [
		10811,
		7,
		10811
	],
	"./lt/_lib/formatDistance/": [
		10811,
		7,
		10811
	],
	"./lt/_lib/formatDistance/index": [
		10811,
		7,
		10811
	],
	"./lt/_lib/formatDistance/index.js": [
		10811,
		7,
		10811
	],
	"./lt/_lib/formatLong": [
		12640,
		7,
		12640
	],
	"./lt/_lib/formatLong/": [
		12640,
		7,
		12640
	],
	"./lt/_lib/formatLong/index": [
		12640,
		7,
		12640
	],
	"./lt/_lib/formatLong/index.js": [
		12640,
		7,
		12640
	],
	"./lt/_lib/formatRelative": [
		58327,
		7,
		73407
	],
	"./lt/_lib/formatRelative/": [
		58327,
		7,
		73407
	],
	"./lt/_lib/formatRelative/index": [
		58327,
		7,
		73407
	],
	"./lt/_lib/formatRelative/index.js": [
		58327,
		7,
		73407
	],
	"./lt/_lib/localize": [
		55143,
		7,
		55143
	],
	"./lt/_lib/localize/": [
		55143,
		7,
		55143
	],
	"./lt/_lib/localize/index": [
		55143,
		7,
		55143
	],
	"./lt/_lib/localize/index.js": [
		55143,
		7,
		55143
	],
	"./lt/_lib/match": [
		87210,
		7,
		87210
	],
	"./lt/_lib/match/": [
		87210,
		7,
		87210
	],
	"./lt/_lib/match/index": [
		87210,
		7,
		87210
	],
	"./lt/_lib/match/index.js": [
		87210,
		7,
		87210
	],
	"./lt/index": [
		4276,
		7,
		4276
	],
	"./lt/index.d": [
		45534,
		9,
		45534
	],
	"./lt/index.d.ts": [
		45534,
		9,
		45534
	],
	"./lt/index.js": [
		4276,
		7,
		4276
	],
	"./lt/index.js.flow": [
		26437,
		7,
		26437
	],
	"./lt/package": [
		82125,
		3,
		82125
	],
	"./lt/package.json": [
		82125,
		3,
		82125
	],
	"./lv": [
		50408,
		9,
		2901
	],
	"./lv/": [
		50408,
		9,
		2901
	],
	"./lv/_lib/formatDistance": [
		19557,
		7,
		19557
	],
	"./lv/_lib/formatDistance/": [
		19557,
		7,
		19557
	],
	"./lv/_lib/formatDistance/index": [
		19557,
		7,
		19557
	],
	"./lv/_lib/formatDistance/index.js": [
		19557,
		7,
		19557
	],
	"./lv/_lib/formatLong": [
		43172,
		7,
		43172
	],
	"./lv/_lib/formatLong/": [
		43172,
		7,
		43172
	],
	"./lv/_lib/formatLong/index": [
		43172,
		7,
		43172
	],
	"./lv/_lib/formatLong/index.js": [
		43172,
		7,
		43172
	],
	"./lv/_lib/formatRelative": [
		47845,
		7,
		73464
	],
	"./lv/_lib/formatRelative/": [
		47845,
		7,
		73464
	],
	"./lv/_lib/formatRelative/index": [
		47845,
		7,
		73464
	],
	"./lv/_lib/formatRelative/index.js": [
		47845,
		7,
		73464
	],
	"./lv/_lib/localize": [
		61524,
		7,
		61524
	],
	"./lv/_lib/localize/": [
		61524,
		7,
		61524
	],
	"./lv/_lib/localize/index": [
		61524,
		7,
		61524
	],
	"./lv/_lib/localize/index.js": [
		61524,
		7,
		61524
	],
	"./lv/_lib/match": [
		3233,
		7,
		3233
	],
	"./lv/_lib/match/": [
		3233,
		7,
		3233
	],
	"./lv/_lib/match/index": [
		3233,
		7,
		3233
	],
	"./lv/_lib/match/index.js": [
		3233,
		7,
		3233
	],
	"./lv/index": [
		78558,
		7,
		78558
	],
	"./lv/index.d": [
		2901,
		9,
		2901
	],
	"./lv/index.d.ts": [
		2901,
		9,
		2901
	],
	"./lv/index.js": [
		78558,
		7,
		78558
	],
	"./lv/index.js.flow": [
		97566,
		7,
		97566
	],
	"./lv/package": [
		88819,
		3,
		88819
	],
	"./lv/package.json": [
		88819,
		3,
		88819
	],
	"./mk": [
		87555,
		9,
		69977
	],
	"./mk/": [
		87555,
		9,
		69977
	],
	"./mk/_lib/formatDistance": [
		81730,
		7,
		81730
	],
	"./mk/_lib/formatDistance/": [
		81730,
		7,
		81730
	],
	"./mk/_lib/formatDistance/index": [
		81730,
		7,
		81730
	],
	"./mk/_lib/formatDistance/index.js": [
		81730,
		7,
		81730
	],
	"./mk/_lib/formatLong": [
		85413,
		7,
		85413
	],
	"./mk/_lib/formatLong/": [
		85413,
		7,
		85413
	],
	"./mk/_lib/formatLong/index": [
		85413,
		7,
		85413
	],
	"./mk/_lib/formatLong/index.js": [
		85413,
		7,
		85413
	],
	"./mk/_lib/formatRelative": [
		18707,
		7,
		46675
	],
	"./mk/_lib/formatRelative/": [
		18707,
		7,
		46675
	],
	"./mk/_lib/formatRelative/index": [
		18707,
		7,
		46675
	],
	"./mk/_lib/formatRelative/index.js": [
		18707,
		7,
		46675
	],
	"./mk/_lib/localize": [
		60421,
		7,
		60421
	],
	"./mk/_lib/localize/": [
		60421,
		7,
		60421
	],
	"./mk/_lib/localize/index": [
		60421,
		7,
		60421
	],
	"./mk/_lib/localize/index.js": [
		60421,
		7,
		60421
	],
	"./mk/_lib/match": [
		98052,
		7,
		98052
	],
	"./mk/_lib/match/": [
		98052,
		7,
		98052
	],
	"./mk/_lib/match/index": [
		98052,
		7,
		98052
	],
	"./mk/_lib/match/index.js": [
		98052,
		7,
		98052
	],
	"./mk/index": [
		94833,
		7,
		94833
	],
	"./mk/index.d": [
		69977,
		9,
		69977
	],
	"./mk/index.d.ts": [
		69977,
		9,
		69977
	],
	"./mk/index.js": [
		94833,
		7,
		94833
	],
	"./mk/index.js.flow": [
		77240,
		7,
		77240
	],
	"./mk/package": [
		77818,
		3,
		77818
	],
	"./mk/package.json": [
		77818,
		3,
		77818
	],
	"./mn": [
		60439,
		9,
		41610
	],
	"./mn/": [
		60439,
		9,
		41610
	],
	"./mn/_lib/formatDistance": [
		89830,
		7,
		89830
	],
	"./mn/_lib/formatDistance/": [
		89830,
		7,
		89830
	],
	"./mn/_lib/formatDistance/index": [
		89830,
		7,
		89830
	],
	"./mn/_lib/formatDistance/index.js": [
		89830,
		7,
		89830
	],
	"./mn/_lib/formatLong": [
		18485,
		7,
		18485
	],
	"./mn/_lib/formatLong/": [
		18485,
		7,
		18485
	],
	"./mn/_lib/formatLong/index": [
		18485,
		7,
		18485
	],
	"./mn/_lib/formatLong/index.js": [
		18485,
		7,
		18485
	],
	"./mn/_lib/formatRelative": [
		65258,
		7,
		65258
	],
	"./mn/_lib/formatRelative/": [
		65258,
		7,
		65258
	],
	"./mn/_lib/formatRelative/index": [
		65258,
		7,
		65258
	],
	"./mn/_lib/formatRelative/index.js": [
		65258,
		7,
		65258
	],
	"./mn/_lib/localize": [
		21599,
		7,
		21599
	],
	"./mn/_lib/localize/": [
		21599,
		7,
		21599
	],
	"./mn/_lib/localize/index": [
		21599,
		7,
		21599
	],
	"./mn/_lib/localize/index.js": [
		21599,
		7,
		21599
	],
	"./mn/_lib/match": [
		52799,
		7,
		52799
	],
	"./mn/_lib/match/": [
		52799,
		7,
		52799
	],
	"./mn/_lib/match/index": [
		52799,
		7,
		52799
	],
	"./mn/_lib/match/index.js": [
		52799,
		7,
		52799
	],
	"./mn/index": [
		14670,
		7,
		14670
	],
	"./mn/index.d": [
		41610,
		9,
		41610
	],
	"./mn/index.d.ts": [
		41610,
		9,
		41610
	],
	"./mn/index.js": [
		14670,
		7,
		14670
	],
	"./mn/index.js.flow": [
		79560,
		7,
		79560
	],
	"./mn/package": [
		10023,
		3,
		10023
	],
	"./mn/package.json": [
		10023,
		3,
		10023
	],
	"./ms": [
		21641,
		9,
		56357
	],
	"./ms/": [
		21641,
		9,
		56357
	],
	"./ms/_lib/formatDistance": [
		30108,
		7,
		30108
	],
	"./ms/_lib/formatDistance/": [
		30108,
		7,
		30108
	],
	"./ms/_lib/formatDistance/index": [
		30108,
		7,
		30108
	],
	"./ms/_lib/formatDistance/index.js": [
		30108,
		7,
		30108
	],
	"./ms/_lib/formatLong": [
		46290,
		7,
		46290
	],
	"./ms/_lib/formatLong/": [
		46290,
		7,
		46290
	],
	"./ms/_lib/formatLong/index": [
		46290,
		7,
		46290
	],
	"./ms/_lib/formatLong/index.js": [
		46290,
		7,
		46290
	],
	"./ms/_lib/formatRelative": [
		46037,
		7,
		46037
	],
	"./ms/_lib/formatRelative/": [
		46037,
		7,
		46037
	],
	"./ms/_lib/formatRelative/index": [
		46037,
		7,
		46037
	],
	"./ms/_lib/formatRelative/index.js": [
		46037,
		7,
		46037
	],
	"./ms/_lib/localize": [
		57474,
		7,
		57474
	],
	"./ms/_lib/localize/": [
		57474,
		7,
		57474
	],
	"./ms/_lib/localize/index": [
		57474,
		7,
		57474
	],
	"./ms/_lib/localize/index.js": [
		57474,
		7,
		57474
	],
	"./ms/_lib/match": [
		15834,
		7,
		15834
	],
	"./ms/_lib/match/": [
		15834,
		7,
		15834
	],
	"./ms/_lib/match/index": [
		15834,
		7,
		15834
	],
	"./ms/_lib/match/index.js": [
		15834,
		7,
		15834
	],
	"./ms/index": [
		21478,
		7,
		21478
	],
	"./ms/index.d": [
		56357,
		9,
		56357
	],
	"./ms/index.d.ts": [
		56357,
		9,
		56357
	],
	"./ms/index.js": [
		21478,
		7,
		21478
	],
	"./ms/index.js.flow": [
		6138,
		7,
		6138
	],
	"./ms/package": [
		79249,
		3,
		79249
	],
	"./ms/package.json": [
		79249,
		3,
		79249
	],
	"./mt": [
		72197,
		9,
		16178
	],
	"./mt/": [
		72197,
		9,
		16178
	],
	"./mt/_lib/formatDistance": [
		74646,
		7,
		74646
	],
	"./mt/_lib/formatDistance/": [
		74646,
		7,
		74646
	],
	"./mt/_lib/formatDistance/index": [
		74646,
		7,
		74646
	],
	"./mt/_lib/formatDistance/index.js": [
		74646,
		7,
		74646
	],
	"./mt/_lib/formatLong": [
		31810,
		7,
		31810
	],
	"./mt/_lib/formatLong/": [
		31810,
		7,
		31810
	],
	"./mt/_lib/formatLong/index": [
		31810,
		7,
		31810
	],
	"./mt/_lib/formatLong/index.js": [
		31810,
		7,
		31810
	],
	"./mt/_lib/formatRelative": [
		72315,
		7,
		72315
	],
	"./mt/_lib/formatRelative/": [
		72315,
		7,
		72315
	],
	"./mt/_lib/formatRelative/index": [
		72315,
		7,
		72315
	],
	"./mt/_lib/formatRelative/index.js": [
		72315,
		7,
		72315
	],
	"./mt/_lib/localize": [
		5161,
		7,
		5161
	],
	"./mt/_lib/localize/": [
		5161,
		7,
		5161
	],
	"./mt/_lib/localize/index": [
		5161,
		7,
		5161
	],
	"./mt/_lib/localize/index.js": [
		5161,
		7,
		5161
	],
	"./mt/_lib/match": [
		1507,
		7,
		1507
	],
	"./mt/_lib/match/": [
		1507,
		7,
		1507
	],
	"./mt/_lib/match/index": [
		1507,
		7,
		1507
	],
	"./mt/_lib/match/index.js": [
		1507,
		7,
		1507
	],
	"./mt/index": [
		32048,
		7,
		64098
	],
	"./mt/index.d": [
		16178,
		9,
		16178
	],
	"./mt/index.d.ts": [
		16178,
		9,
		16178
	],
	"./mt/index.js": [
		32048,
		7,
		64098
	],
	"./mt/index.js.flow": [
		44465,
		7,
		44465
	],
	"./mt/package": [
		6934,
		3,
		6934
	],
	"./mt/package.json": [
		6934,
		3,
		6934
	],
	"./nb": [
		17498,
		9,
		36241
	],
	"./nb/": [
		17498,
		9,
		36241
	],
	"./nb/_lib/formatDistance": [
		14599,
		7,
		14599
	],
	"./nb/_lib/formatDistance/": [
		14599,
		7,
		14599
	],
	"./nb/_lib/formatDistance/index": [
		14599,
		7,
		14599
	],
	"./nb/_lib/formatDistance/index.js": [
		14599,
		7,
		14599
	],
	"./nb/_lib/formatLong": [
		79673,
		7,
		79673
	],
	"./nb/_lib/formatLong/": [
		79673,
		7,
		79673
	],
	"./nb/_lib/formatLong/index": [
		79673,
		7,
		79673
	],
	"./nb/_lib/formatLong/index.js": [
		79673,
		7,
		79673
	],
	"./nb/_lib/formatRelative": [
		59507,
		7,
		59507
	],
	"./nb/_lib/formatRelative/": [
		59507,
		7,
		59507
	],
	"./nb/_lib/formatRelative/index": [
		59507,
		7,
		59507
	],
	"./nb/_lib/formatRelative/index.js": [
		59507,
		7,
		59507
	],
	"./nb/_lib/localize": [
		74660,
		7,
		74660
	],
	"./nb/_lib/localize/": [
		74660,
		7,
		74660
	],
	"./nb/_lib/localize/index": [
		74660,
		7,
		74660
	],
	"./nb/_lib/localize/index.js": [
		74660,
		7,
		74660
	],
	"./nb/_lib/match": [
		55420,
		7,
		55420
	],
	"./nb/_lib/match/": [
		55420,
		7,
		55420
	],
	"./nb/_lib/match/index": [
		55420,
		7,
		55420
	],
	"./nb/_lib/match/index.js": [
		55420,
		7,
		55420
	],
	"./nb/index": [
		4241,
		7,
		4241
	],
	"./nb/index.d": [
		36241,
		9,
		36241
	],
	"./nb/index.d.ts": [
		36241,
		9,
		36241
	],
	"./nb/index.js": [
		4241,
		7,
		4241
	],
	"./nb/index.js.flow": [
		55926,
		7,
		55926
	],
	"./nb/package": [
		63691,
		3,
		63691
	],
	"./nb/package.json": [
		63691,
		3,
		63691
	],
	"./nl": [
		35845,
		9,
		43336
	],
	"./nl-BE": [
		44853,
		9,
		65712
	],
	"./nl-BE/": [
		44853,
		9,
		65712
	],
	"./nl-BE/_lib/formatDistance": [
		99885,
		7,
		99885
	],
	"./nl-BE/_lib/formatDistance/": [
		99885,
		7,
		99885
	],
	"./nl-BE/_lib/formatDistance/index": [
		99885,
		7,
		99885
	],
	"./nl-BE/_lib/formatDistance/index.js": [
		99885,
		7,
		99885
	],
	"./nl-BE/_lib/formatLong": [
		46906,
		7,
		46906
	],
	"./nl-BE/_lib/formatLong/": [
		46906,
		7,
		46906
	],
	"./nl-BE/_lib/formatLong/index": [
		46906,
		7,
		46906
	],
	"./nl-BE/_lib/formatLong/index.js": [
		46906,
		7,
		46906
	],
	"./nl-BE/_lib/formatRelative": [
		55992,
		7,
		55992
	],
	"./nl-BE/_lib/formatRelative/": [
		55992,
		7,
		55992
	],
	"./nl-BE/_lib/formatRelative/index": [
		55992,
		7,
		55992
	],
	"./nl-BE/_lib/formatRelative/index.js": [
		55992,
		7,
		55992
	],
	"./nl-BE/_lib/localize": [
		79166,
		7,
		79166
	],
	"./nl-BE/_lib/localize/": [
		79166,
		7,
		79166
	],
	"./nl-BE/_lib/localize/index": [
		79166,
		7,
		79166
	],
	"./nl-BE/_lib/localize/index.js": [
		79166,
		7,
		79166
	],
	"./nl-BE/_lib/match": [
		62225,
		7,
		62225
	],
	"./nl-BE/_lib/match/": [
		62225,
		7,
		62225
	],
	"./nl-BE/_lib/match/index": [
		62225,
		7,
		62225
	],
	"./nl-BE/_lib/match/index.js": [
		62225,
		7,
		62225
	],
	"./nl-BE/index": [
		25874,
		7,
		25874
	],
	"./nl-BE/index.d": [
		65712,
		9,
		65712
	],
	"./nl-BE/index.d.ts": [
		65712,
		9,
		65712
	],
	"./nl-BE/index.js": [
		25874,
		7,
		25874
	],
	"./nl-BE/index.js.flow": [
		40886,
		7,
		40886
	],
	"./nl-BE/package": [
		92797,
		3,
		92797
	],
	"./nl-BE/package.json": [
		92797,
		3,
		92797
	],
	"./nl/": [
		35845,
		9,
		43336
	],
	"./nl/_lib/formatDistance": [
		88618,
		7,
		88618
	],
	"./nl/_lib/formatDistance/": [
		88618,
		7,
		88618
	],
	"./nl/_lib/formatDistance/index": [
		88618,
		7,
		88618
	],
	"./nl/_lib/formatDistance/index.js": [
		88618,
		7,
		88618
	],
	"./nl/_lib/formatLong": [
		56262,
		7,
		56262
	],
	"./nl/_lib/formatLong/": [
		56262,
		7,
		56262
	],
	"./nl/_lib/formatLong/index": [
		56262,
		7,
		56262
	],
	"./nl/_lib/formatLong/index.js": [
		56262,
		7,
		56262
	],
	"./nl/_lib/formatRelative": [
		56383,
		7,
		56383
	],
	"./nl/_lib/formatRelative/": [
		56383,
		7,
		56383
	],
	"./nl/_lib/formatRelative/index": [
		56383,
		7,
		56383
	],
	"./nl/_lib/formatRelative/index.js": [
		56383,
		7,
		56383
	],
	"./nl/_lib/localize": [
		6896,
		7,
		6896
	],
	"./nl/_lib/localize/": [
		6896,
		7,
		6896
	],
	"./nl/_lib/localize/index": [
		6896,
		7,
		6896
	],
	"./nl/_lib/localize/index.js": [
		6896,
		7,
		6896
	],
	"./nl/_lib/match": [
		51242,
		7,
		51242
	],
	"./nl/_lib/match/": [
		51242,
		7,
		51242
	],
	"./nl/_lib/match/index": [
		51242,
		7,
		51242
	],
	"./nl/_lib/match/index.js": [
		51242,
		7,
		51242
	],
	"./nl/index": [
		3716,
		7,
		3716
	],
	"./nl/index.d": [
		43336,
		9,
		43336
	],
	"./nl/index.d.ts": [
		43336,
		9,
		43336
	],
	"./nl/index.js": [
		3716,
		7,
		3716
	],
	"./nl/index.js.flow": [
		3145,
		7,
		3145
	],
	"./nl/package": [
		68791,
		3,
		68791
	],
	"./nl/package.json": [
		68791,
		3,
		68791
	],
	"./nn": [
		48526,
		9,
		46637
	],
	"./nn/": [
		48526,
		9,
		46637
	],
	"./nn/_lib/formatDistance": [
		7974,
		7,
		7974
	],
	"./nn/_lib/formatDistance/": [
		7974,
		7,
		7974
	],
	"./nn/_lib/formatDistance/index": [
		7974,
		7,
		7974
	],
	"./nn/_lib/formatDistance/index.js": [
		7974,
		7,
		7974
	],
	"./nn/_lib/formatLong": [
		76009,
		7,
		76009
	],
	"./nn/_lib/formatLong/": [
		76009,
		7,
		76009
	],
	"./nn/_lib/formatLong/index": [
		76009,
		7,
		76009
	],
	"./nn/_lib/formatLong/index.js": [
		76009,
		7,
		76009
	],
	"./nn/_lib/formatRelative": [
		36477,
		7,
		36477
	],
	"./nn/_lib/formatRelative/": [
		36477,
		7,
		36477
	],
	"./nn/_lib/formatRelative/index": [
		36477,
		7,
		36477
	],
	"./nn/_lib/formatRelative/index.js": [
		36477,
		7,
		36477
	],
	"./nn/_lib/localize": [
		51447,
		7,
		51447
	],
	"./nn/_lib/localize/": [
		51447,
		7,
		51447
	],
	"./nn/_lib/localize/index": [
		51447,
		7,
		51447
	],
	"./nn/_lib/localize/index.js": [
		51447,
		7,
		51447
	],
	"./nn/_lib/match": [
		25022,
		7,
		25022
	],
	"./nn/_lib/match/": [
		25022,
		7,
		25022
	],
	"./nn/_lib/match/index": [
		25022,
		7,
		25022
	],
	"./nn/_lib/match/index.js": [
		25022,
		7,
		25022
	],
	"./nn/index": [
		87314,
		7,
		87314
	],
	"./nn/index.d": [
		46637,
		9,
		46637
	],
	"./nn/index.d.ts": [
		46637,
		9,
		46637
	],
	"./nn/index.js": [
		87314,
		7,
		87314
	],
	"./nn/index.js.flow": [
		90667,
		7,
		90667
	],
	"./nn/package": [
		46111,
		3,
		46111
	],
	"./nn/package.json": [
		46111,
		3,
		46111
	],
	"./oc": [
		19997,
		9,
		81883
	],
	"./oc/": [
		19997,
		9,
		81883
	],
	"./oc/_lib/formatDistance": [
		27702,
		7,
		27702
	],
	"./oc/_lib/formatDistance/": [
		27702,
		7,
		27702
	],
	"./oc/_lib/formatDistance/index": [
		27702,
		7,
		27702
	],
	"./oc/_lib/formatDistance/index.js": [
		27702,
		7,
		27702
	],
	"./oc/_lib/formatLong": [
		49614,
		7,
		49614
	],
	"./oc/_lib/formatLong/": [
		49614,
		7,
		49614
	],
	"./oc/_lib/formatLong/index": [
		49614,
		7,
		49614
	],
	"./oc/_lib/formatLong/index.js": [
		49614,
		7,
		49614
	],
	"./oc/_lib/formatRelative": [
		97607,
		7,
		97607
	],
	"./oc/_lib/formatRelative/": [
		97607,
		7,
		97607
	],
	"./oc/_lib/formatRelative/index": [
		97607,
		7,
		97607
	],
	"./oc/_lib/formatRelative/index.js": [
		97607,
		7,
		97607
	],
	"./oc/_lib/localize": [
		78358,
		7,
		78358
	],
	"./oc/_lib/localize/": [
		78358,
		7,
		78358
	],
	"./oc/_lib/localize/index": [
		78358,
		7,
		78358
	],
	"./oc/_lib/localize/index.js": [
		78358,
		7,
		78358
	],
	"./oc/_lib/match": [
		87020,
		7,
		87020
	],
	"./oc/_lib/match/": [
		87020,
		7,
		87020
	],
	"./oc/_lib/match/index": [
		87020,
		7,
		87020
	],
	"./oc/_lib/match/index.js": [
		87020,
		7,
		87020
	],
	"./oc/index": [
		23883,
		7,
		23883
	],
	"./oc/index.d": [
		81883,
		9,
		81883
	],
	"./oc/index.d.ts": [
		81883,
		9,
		81883
	],
	"./oc/index.js": [
		23883,
		7,
		23883
	],
	"./oc/index.js.flow": [
		65989,
		7,
		65989
	],
	"./oc/package": [
		68259,
		3,
		68259
	],
	"./oc/package.json": [
		68259,
		3,
		68259
	],
	"./package": [
		87852,
		3,
		87852
	],
	"./package.json": [
		87852,
		3,
		87852
	],
	"./pl": [
		32638,
		9,
		74622
	],
	"./pl/": [
		32638,
		9,
		74622
	],
	"./pl/_lib/formatDistance": [
		89375,
		7,
		89375
	],
	"./pl/_lib/formatDistance/": [
		89375,
		7,
		89375
	],
	"./pl/_lib/formatDistance/index": [
		89375,
		7,
		89375
	],
	"./pl/_lib/formatDistance/index.js": [
		89375,
		7,
		89375
	],
	"./pl/_lib/formatLong": [
		54402,
		7,
		54402
	],
	"./pl/_lib/formatLong/": [
		54402,
		7,
		54402
	],
	"./pl/_lib/formatLong/index": [
		54402,
		7,
		54402
	],
	"./pl/_lib/formatLong/index.js": [
		54402,
		7,
		54402
	],
	"./pl/_lib/formatRelative": [
		93552,
		7,
		5510
	],
	"./pl/_lib/formatRelative/": [
		93552,
		7,
		5510
	],
	"./pl/_lib/formatRelative/index": [
		93552,
		7,
		5510
	],
	"./pl/_lib/formatRelative/index.js": [
		93552,
		7,
		5510
	],
	"./pl/_lib/localize": [
		64991,
		7,
		64991
	],
	"./pl/_lib/localize/": [
		64991,
		7,
		64991
	],
	"./pl/_lib/localize/index": [
		64991,
		7,
		64991
	],
	"./pl/_lib/localize/index.js": [
		64991,
		7,
		64991
	],
	"./pl/_lib/match": [
		15352,
		7,
		15352
	],
	"./pl/_lib/match/": [
		15352,
		7,
		15352
	],
	"./pl/_lib/match/index": [
		15352,
		7,
		15352
	],
	"./pl/_lib/match/index.js": [
		15352,
		7,
		15352
	],
	"./pl/index": [
		87672,
		7,
		87672
	],
	"./pl/index.d": [
		74622,
		9,
		74622
	],
	"./pl/index.d.ts": [
		74622,
		9,
		74622
	],
	"./pl/index.js": [
		87672,
		7,
		87672
	],
	"./pl/index.js.flow": [
		56616,
		7,
		56616
	],
	"./pl/package": [
		69261,
		3,
		69261
	],
	"./pl/package.json": [
		69261,
		3,
		69261
	],
	"./pt": [
		91371,
		9,
		4923
	],
	"./pt-BR": [
		51490,
		9,
		49414
	],
	"./pt-BR/": [
		51490,
		9,
		49414
	],
	"./pt-BR/_lib/formatDistance": [
		58790,
		7,
		58790
	],
	"./pt-BR/_lib/formatDistance/": [
		58790,
		7,
		58790
	],
	"./pt-BR/_lib/formatDistance/index": [
		58790,
		7,
		58790
	],
	"./pt-BR/_lib/formatDistance/index.js": [
		58790,
		7,
		58790
	],
	"./pt-BR/_lib/formatLong": [
		633,
		7,
		633
	],
	"./pt-BR/_lib/formatLong/": [
		633,
		7,
		633
	],
	"./pt-BR/_lib/formatLong/index": [
		633,
		7,
		633
	],
	"./pt-BR/_lib/formatLong/index.js": [
		633,
		7,
		633
	],
	"./pt-BR/_lib/formatRelative": [
		10075,
		7,
		10075
	],
	"./pt-BR/_lib/formatRelative/": [
		10075,
		7,
		10075
	],
	"./pt-BR/_lib/formatRelative/index": [
		10075,
		7,
		10075
	],
	"./pt-BR/_lib/formatRelative/index.js": [
		10075,
		7,
		10075
	],
	"./pt-BR/_lib/localize": [
		20927,
		7,
		20927
	],
	"./pt-BR/_lib/localize/": [
		20927,
		7,
		20927
	],
	"./pt-BR/_lib/localize/index": [
		20927,
		7,
		20927
	],
	"./pt-BR/_lib/localize/index.js": [
		20927,
		7,
		20927
	],
	"./pt-BR/_lib/match": [
		99801,
		7,
		99801
	],
	"./pt-BR/_lib/match/": [
		99801,
		7,
		99801
	],
	"./pt-BR/_lib/match/index": [
		99801,
		7,
		99801
	],
	"./pt-BR/_lib/match/index.js": [
		99801,
		7,
		99801
	],
	"./pt-BR/index": [
		60528,
		7,
		60528
	],
	"./pt-BR/index.d": [
		49414,
		9,
		49414
	],
	"./pt-BR/index.d.ts": [
		49414,
		9,
		49414
	],
	"./pt-BR/index.js": [
		60528,
		7,
		60528
	],
	"./pt-BR/index.js.flow": [
		10449,
		7,
		10449
	],
	"./pt-BR/package": [
		50589,
		3,
		50589
	],
	"./pt-BR/package.json": [
		50589,
		3,
		50589
	],
	"./pt/": [
		91371,
		9,
		4923
	],
	"./pt/_lib/formatDistance": [
		6163,
		7,
		6163
	],
	"./pt/_lib/formatDistance/": [
		6163,
		7,
		6163
	],
	"./pt/_lib/formatDistance/index": [
		6163,
		7,
		6163
	],
	"./pt/_lib/formatDistance/index.js": [
		6163,
		7,
		6163
	],
	"./pt/_lib/formatLong": [
		34770,
		7,
		99724
	],
	"./pt/_lib/formatLong/": [
		34770,
		7,
		99724
	],
	"./pt/_lib/formatLong/index": [
		34770,
		7,
		99724
	],
	"./pt/_lib/formatLong/index.js": [
		34770,
		7,
		99724
	],
	"./pt/_lib/formatRelative": [
		95240,
		7,
		95240
	],
	"./pt/_lib/formatRelative/": [
		95240,
		7,
		95240
	],
	"./pt/_lib/formatRelative/index": [
		95240,
		7,
		95240
	],
	"./pt/_lib/formatRelative/index.js": [
		95240,
		7,
		95240
	],
	"./pt/_lib/localize": [
		99337,
		7,
		65882
	],
	"./pt/_lib/localize/": [
		99337,
		7,
		65882
	],
	"./pt/_lib/localize/index": [
		99337,
		7,
		65882
	],
	"./pt/_lib/localize/index.js": [
		99337,
		7,
		65882
	],
	"./pt/_lib/match": [
		81314,
		7,
		81314
	],
	"./pt/_lib/match/": [
		81314,
		7,
		81314
	],
	"./pt/_lib/match/index": [
		81314,
		7,
		81314
	],
	"./pt/_lib/match/index.js": [
		81314,
		7,
		81314
	],
	"./pt/index": [
		1,
		7,
		1
	],
	"./pt/index.d": [
		4923,
		9,
		4923
	],
	"./pt/index.d.ts": [
		4923,
		9,
		4923
	],
	"./pt/index.js": [
		1,
		7,
		1
	],
	"./pt/index.js.flow": [
		6456,
		7,
		6456
	],
	"./pt/package": [
		3048,
		3,
		3048
	],
	"./pt/package.json": [
		3048,
		3,
		3048
	],
	"./ro": [
		56434,
		9,
		47150
	],
	"./ro/": [
		56434,
		9,
		47150
	],
	"./ro/_lib/formatDistance": [
		84317,
		7,
		84317
	],
	"./ro/_lib/formatDistance/": [
		84317,
		7,
		84317
	],
	"./ro/_lib/formatDistance/index": [
		84317,
		7,
		84317
	],
	"./ro/_lib/formatDistance/index.js": [
		84317,
		7,
		84317
	],
	"./ro/_lib/formatLong": [
		57057,
		7,
		57057
	],
	"./ro/_lib/formatLong/": [
		57057,
		7,
		57057
	],
	"./ro/_lib/formatLong/index": [
		57057,
		7,
		57057
	],
	"./ro/_lib/formatLong/index.js": [
		57057,
		7,
		57057
	],
	"./ro/_lib/formatRelative": [
		54785,
		7,
		82443
	],
	"./ro/_lib/formatRelative/": [
		54785,
		7,
		82443
	],
	"./ro/_lib/formatRelative/index": [
		54785,
		7,
		82443
	],
	"./ro/_lib/formatRelative/index.js": [
		54785,
		7,
		82443
	],
	"./ro/_lib/localize": [
		63608,
		7,
		63608
	],
	"./ro/_lib/localize/": [
		63608,
		7,
		63608
	],
	"./ro/_lib/localize/index": [
		63608,
		7,
		63608
	],
	"./ro/_lib/localize/index.js": [
		63608,
		7,
		63608
	],
	"./ro/_lib/match": [
		97139,
		7,
		97139
	],
	"./ro/_lib/match/": [
		97139,
		7,
		97139
	],
	"./ro/_lib/match/index": [
		97139,
		7,
		97139
	],
	"./ro/_lib/match/index.js": [
		97139,
		7,
		97139
	],
	"./ro/index": [
		855,
		7,
		855
	],
	"./ro/index.d": [
		47150,
		9,
		47150
	],
	"./ro/index.d.ts": [
		47150,
		9,
		47150
	],
	"./ro/index.js": [
		855,
		7,
		855
	],
	"./ro/index.js.flow": [
		97812,
		7,
		97812
	],
	"./ro/package": [
		78573,
		3,
		78573
	],
	"./ro/package.json": [
		78573,
		3,
		78573
	],
	"./ru": [
		10203,
		9,
		76610
	],
	"./ru/": [
		10203,
		9,
		76610
	],
	"./ru/_lib/formatDistance": [
		42793,
		7,
		42793
	],
	"./ru/_lib/formatDistance/": [
		42793,
		7,
		42793
	],
	"./ru/_lib/formatDistance/index": [
		42793,
		7,
		42793
	],
	"./ru/_lib/formatDistance/index.js": [
		42793,
		7,
		42793
	],
	"./ru/_lib/formatLong": [
		12119,
		7,
		12119
	],
	"./ru/_lib/formatLong/": [
		12119,
		7,
		12119
	],
	"./ru/_lib/formatLong/index": [
		12119,
		7,
		12119
	],
	"./ru/_lib/formatLong/index.js": [
		12119,
		7,
		12119
	],
	"./ru/_lib/formatRelative": [
		80503,
		7,
		46675
	],
	"./ru/_lib/formatRelative/": [
		80503,
		7,
		46675
	],
	"./ru/_lib/formatRelative/index": [
		80503,
		7,
		46675
	],
	"./ru/_lib/formatRelative/index.js": [
		80503,
		7,
		46675
	],
	"./ru/_lib/localize": [
		69237,
		7,
		69237
	],
	"./ru/_lib/localize/": [
		69237,
		7,
		69237
	],
	"./ru/_lib/localize/index": [
		69237,
		7,
		69237
	],
	"./ru/_lib/localize/index.js": [
		69237,
		7,
		69237
	],
	"./ru/_lib/match": [
		5584,
		7,
		5584
	],
	"./ru/_lib/match/": [
		5584,
		7,
		5584
	],
	"./ru/_lib/match/index": [
		5584,
		7,
		5584
	],
	"./ru/_lib/match/index.js": [
		5584,
		7,
		5584
	],
	"./ru/index": [
		5259,
		7,
		5259
	],
	"./ru/index.d": [
		76610,
		9,
		76610
	],
	"./ru/index.d.ts": [
		76610,
		9,
		76610
	],
	"./ru/index.js": [
		5259,
		7,
		5259
	],
	"./ru/index.js.flow": [
		53437,
		7,
		53437
	],
	"./ru/package": [
		30004,
		3,
		30004
	],
	"./ru/package.json": [
		30004,
		3,
		30004
	],
	"./sk": [
		77637,
		9,
		87037
	],
	"./sk/": [
		77637,
		9,
		87037
	],
	"./sk/_lib/formatDistance": [
		42812,
		7,
		42812
	],
	"./sk/_lib/formatDistance/": [
		42812,
		7,
		42812
	],
	"./sk/_lib/formatDistance/index": [
		42812,
		7,
		42812
	],
	"./sk/_lib/formatDistance/index.js": [
		42812,
		7,
		42812
	],
	"./sk/_lib/formatLong": [
		78208,
		7,
		78208
	],
	"./sk/_lib/formatLong/": [
		78208,
		7,
		78208
	],
	"./sk/_lib/formatLong/index": [
		78208,
		7,
		78208
	],
	"./sk/_lib/formatLong/index.js": [
		78208,
		7,
		78208
	],
	"./sk/_lib/formatRelative": [
		72350,
		7,
		5510
	],
	"./sk/_lib/formatRelative/": [
		72350,
		7,
		5510
	],
	"./sk/_lib/formatRelative/index": [
		72350,
		7,
		5510
	],
	"./sk/_lib/formatRelative/index.js": [
		72350,
		7,
		5510
	],
	"./sk/_lib/localize": [
		47679,
		7,
		47679
	],
	"./sk/_lib/localize/": [
		47679,
		7,
		47679
	],
	"./sk/_lib/localize/index": [
		47679,
		7,
		47679
	],
	"./sk/_lib/localize/index.js": [
		47679,
		7,
		47679
	],
	"./sk/_lib/match": [
		44601,
		7,
		44601
	],
	"./sk/_lib/match/": [
		44601,
		7,
		44601
	],
	"./sk/_lib/match/index": [
		44601,
		7,
		44601
	],
	"./sk/_lib/match/index.js": [
		44601,
		7,
		44601
	],
	"./sk/index": [
		46001,
		7,
		46001
	],
	"./sk/index.d": [
		87037,
		9,
		87037
	],
	"./sk/index.d.ts": [
		87037,
		9,
		87037
	],
	"./sk/index.js": [
		46001,
		7,
		46001
	],
	"./sk/index.js.flow": [
		38067,
		7,
		38067
	],
	"./sk/package": [
		64262,
		3,
		64262
	],
	"./sk/package.json": [
		64262,
		3,
		64262
	],
	"./sl": [
		44858,
		9,
		28867
	],
	"./sl/": [
		44858,
		9,
		28867
	],
	"./sl/_lib/formatDistance": [
		92270,
		7,
		92270
	],
	"./sl/_lib/formatDistance/": [
		92270,
		7,
		92270
	],
	"./sl/_lib/formatDistance/index": [
		92270,
		7,
		92270
	],
	"./sl/_lib/formatDistance/index.js": [
		92270,
		7,
		92270
	],
	"./sl/_lib/formatLong": [
		55099,
		7,
		55099
	],
	"./sl/_lib/formatLong/": [
		55099,
		7,
		55099
	],
	"./sl/_lib/formatLong/index": [
		55099,
		7,
		55099
	],
	"./sl/_lib/formatLong/index.js": [
		55099,
		7,
		55099
	],
	"./sl/_lib/formatRelative": [
		98082,
		7,
		98082
	],
	"./sl/_lib/formatRelative/": [
		98082,
		7,
		98082
	],
	"./sl/_lib/formatRelative/index": [
		98082,
		7,
		98082
	],
	"./sl/_lib/formatRelative/index.js": [
		98082,
		7,
		98082
	],
	"./sl/_lib/localize": [
		34198,
		7,
		34198
	],
	"./sl/_lib/localize/": [
		34198,
		7,
		34198
	],
	"./sl/_lib/localize/index": [
		34198,
		7,
		34198
	],
	"./sl/_lib/localize/index.js": [
		34198,
		7,
		34198
	],
	"./sl/_lib/match": [
		6912,
		7,
		6912
	],
	"./sl/_lib/match/": [
		6912,
		7,
		6912
	],
	"./sl/_lib/match/index": [
		6912,
		7,
		6912
	],
	"./sl/_lib/match/index.js": [
		6912,
		7,
		6912
	],
	"./sl/index": [
		79827,
		7,
		79827
	],
	"./sl/index.d": [
		28867,
		9,
		28867
	],
	"./sl/index.d.ts": [
		28867,
		9,
		28867
	],
	"./sl/index.js": [
		79827,
		7,
		79827
	],
	"./sl/index.js.flow": [
		56167,
		7,
		56167
	],
	"./sl/package": [
		96286,
		3,
		96286
	],
	"./sl/package.json": [
		96286,
		3,
		96286
	],
	"./sq": [
		47337,
		9,
		2154
	],
	"./sq/": [
		47337,
		9,
		2154
	],
	"./sq/_lib/formatDistance": [
		64553,
		7,
		64553
	],
	"./sq/_lib/formatDistance/": [
		64553,
		7,
		64553
	],
	"./sq/_lib/formatDistance/index": [
		64553,
		7,
		64553
	],
	"./sq/_lib/formatDistance/index.js": [
		64553,
		7,
		64553
	],
	"./sq/_lib/formatLong": [
		92799,
		7,
		92799
	],
	"./sq/_lib/formatLong/": [
		92799,
		7,
		92799
	],
	"./sq/_lib/formatLong/index": [
		92799,
		7,
		92799
	],
	"./sq/_lib/formatLong/index.js": [
		92799,
		7,
		92799
	],
	"./sq/_lib/formatRelative": [
		55195,
		7,
		55195
	],
	"./sq/_lib/formatRelative/": [
		55195,
		7,
		55195
	],
	"./sq/_lib/formatRelative/index": [
		55195,
		7,
		55195
	],
	"./sq/_lib/formatRelative/index.js": [
		55195,
		7,
		55195
	],
	"./sq/_lib/localize": [
		45161,
		7,
		45161
	],
	"./sq/_lib/localize/": [
		45161,
		7,
		45161
	],
	"./sq/_lib/localize/index": [
		45161,
		7,
		45161
	],
	"./sq/_lib/localize/index.js": [
		45161,
		7,
		45161
	],
	"./sq/_lib/match": [
		11031,
		7,
		11031
	],
	"./sq/_lib/match/": [
		11031,
		7,
		11031
	],
	"./sq/_lib/match/index": [
		11031,
		7,
		11031
	],
	"./sq/_lib/match/index.js": [
		11031,
		7,
		11031
	],
	"./sq/index": [
		47527,
		7,
		47527
	],
	"./sq/index.d": [
		2154,
		9,
		2154
	],
	"./sq/index.d.ts": [
		2154,
		9,
		2154
	],
	"./sq/index.js": [
		47527,
		7,
		47527
	],
	"./sq/index.js.flow": [
		72199,
		7,
		72199
	],
	"./sq/package": [
		46696,
		3,
		46696
	],
	"./sq/package.json": [
		46696,
		3,
		46696
	],
	"./sr": [
		33888,
		9,
		58412
	],
	"./sr-Latn": [
		54303,
		9,
		24769
	],
	"./sr-Latn/": [
		54303,
		9,
		24769
	],
	"./sr-Latn/_lib/formatDistance": [
		88459,
		7,
		88459
	],
	"./sr-Latn/_lib/formatDistance/": [
		88459,
		7,
		88459
	],
	"./sr-Latn/_lib/formatDistance/index": [
		88459,
		7,
		88459
	],
	"./sr-Latn/_lib/formatDistance/index.js": [
		88459,
		7,
		88459
	],
	"./sr-Latn/_lib/formatLong": [
		92295,
		7,
		92295
	],
	"./sr-Latn/_lib/formatLong/": [
		92295,
		7,
		92295
	],
	"./sr-Latn/_lib/formatLong/index": [
		92295,
		7,
		92295
	],
	"./sr-Latn/_lib/formatLong/index.js": [
		92295,
		7,
		92295
	],
	"./sr-Latn/_lib/formatRelative": [
		45116,
		7,
		45116
	],
	"./sr-Latn/_lib/formatRelative/": [
		45116,
		7,
		45116
	],
	"./sr-Latn/_lib/formatRelative/index": [
		45116,
		7,
		45116
	],
	"./sr-Latn/_lib/formatRelative/index.js": [
		45116,
		7,
		45116
	],
	"./sr-Latn/_lib/localize": [
		59288,
		7,
		59288
	],
	"./sr-Latn/_lib/localize/": [
		59288,
		7,
		59288
	],
	"./sr-Latn/_lib/localize/index": [
		59288,
		7,
		59288
	],
	"./sr-Latn/_lib/localize/index.js": [
		59288,
		7,
		59288
	],
	"./sr-Latn/_lib/match": [
		93334,
		7,
		93334
	],
	"./sr-Latn/_lib/match/": [
		93334,
		7,
		93334
	],
	"./sr-Latn/_lib/match/index": [
		93334,
		7,
		93334
	],
	"./sr-Latn/_lib/match/index.js": [
		93334,
		7,
		93334
	],
	"./sr-Latn/index": [
		25472,
		7,
		25472
	],
	"./sr-Latn/index.d": [
		24769,
		9,
		24769
	],
	"./sr-Latn/index.d.ts": [
		24769,
		9,
		24769
	],
	"./sr-Latn/index.js": [
		25472,
		7,
		25472
	],
	"./sr-Latn/index.js.flow": [
		92047,
		7,
		92047
	],
	"./sr-Latn/package": [
		90046,
		3,
		90046
	],
	"./sr-Latn/package.json": [
		90046,
		3,
		90046
	],
	"./sr/": [
		33888,
		9,
		58412
	],
	"./sr/_lib/formatDistance": [
		5041,
		7,
		5041
	],
	"./sr/_lib/formatDistance/": [
		5041,
		7,
		5041
	],
	"./sr/_lib/formatDistance/index": [
		5041,
		7,
		5041
	],
	"./sr/_lib/formatDistance/index.js": [
		5041,
		7,
		5041
	],
	"./sr/_lib/formatLong": [
		1928,
		7,
		1928
	],
	"./sr/_lib/formatLong/": [
		1928,
		7,
		1928
	],
	"./sr/_lib/formatLong/index": [
		1928,
		7,
		1928
	],
	"./sr/_lib/formatLong/index.js": [
		1928,
		7,
		1928
	],
	"./sr/_lib/formatRelative": [
		85095,
		7,
		85095
	],
	"./sr/_lib/formatRelative/": [
		85095,
		7,
		85095
	],
	"./sr/_lib/formatRelative/index": [
		85095,
		7,
		85095
	],
	"./sr/_lib/formatRelative/index.js": [
		85095,
		7,
		85095
	],
	"./sr/_lib/localize": [
		33386,
		7,
		73740
	],
	"./sr/_lib/localize/": [
		33386,
		7,
		73740
	],
	"./sr/_lib/localize/index": [
		33386,
		7,
		73740
	],
	"./sr/_lib/localize/index.js": [
		33386,
		7,
		73740
	],
	"./sr/_lib/match": [
		59756,
		7,
		59756
	],
	"./sr/_lib/match/": [
		59756,
		7,
		59756
	],
	"./sr/_lib/match/index": [
		59756,
		7,
		59756
	],
	"./sr/_lib/match/index.js": [
		59756,
		7,
		59756
	],
	"./sr/index": [
		65103,
		7,
		65103
	],
	"./sr/index.d": [
		58412,
		9,
		58412
	],
	"./sr/index.d.ts": [
		58412,
		9,
		58412
	],
	"./sr/index.js": [
		65103,
		7,
		65103
	],
	"./sr/index.js.flow": [
		82064,
		7,
		82064
	],
	"./sr/package": [
		44046,
		3,
		44046
	],
	"./sr/package.json": [
		44046,
		3,
		44046
	],
	"./sv": [
		23781,
		9,
		59097
	],
	"./sv/": [
		23781,
		9,
		59097
	],
	"./sv/_lib/formatDistance": [
		55987,
		7,
		55987
	],
	"./sv/_lib/formatDistance/": [
		55987,
		7,
		55987
	],
	"./sv/_lib/formatDistance/index": [
		55987,
		7,
		55987
	],
	"./sv/_lib/formatDistance/index.js": [
		55987,
		7,
		55987
	],
	"./sv/_lib/formatLong": [
		56808,
		7,
		56808
	],
	"./sv/_lib/formatLong/": [
		56808,
		7,
		56808
	],
	"./sv/_lib/formatLong/index": [
		56808,
		7,
		56808
	],
	"./sv/_lib/formatLong/index.js": [
		56808,
		7,
		56808
	],
	"./sv/_lib/formatRelative": [
		68547,
		7,
		68547
	],
	"./sv/_lib/formatRelative/": [
		68547,
		7,
		68547
	],
	"./sv/_lib/formatRelative/index": [
		68547,
		7,
		68547
	],
	"./sv/_lib/formatRelative/index.js": [
		68547,
		7,
		68547
	],
	"./sv/_lib/localize": [
		88527,
		7,
		88527
	],
	"./sv/_lib/localize/": [
		88527,
		7,
		88527
	],
	"./sv/_lib/localize/index": [
		88527,
		7,
		88527
	],
	"./sv/_lib/localize/index.js": [
		88527,
		7,
		88527
	],
	"./sv/_lib/match": [
		64882,
		7,
		64882
	],
	"./sv/_lib/match/": [
		64882,
		7,
		64882
	],
	"./sv/_lib/match/index": [
		64882,
		7,
		64882
	],
	"./sv/_lib/match/index.js": [
		64882,
		7,
		64882
	],
	"./sv/index": [
		79279,
		7,
		79279
	],
	"./sv/index.d": [
		59097,
		9,
		59097
	],
	"./sv/index.d.ts": [
		59097,
		9,
		59097
	],
	"./sv/index.js": [
		79279,
		7,
		79279
	],
	"./sv/index.js.flow": [
		44266,
		7,
		44266
	],
	"./sv/package": [
		49767,
		3,
		49767
	],
	"./sv/package.json": [
		49767,
		3,
		49767
	],
	"./ta": [
		44629,
		9,
		85761
	],
	"./ta/": [
		44629,
		9,
		85761
	],
	"./ta/_lib/formatDistance": [
		87139,
		7,
		87139
	],
	"./ta/_lib/formatDistance/": [
		87139,
		7,
		87139
	],
	"./ta/_lib/formatDistance/index": [
		87139,
		7,
		87139
	],
	"./ta/_lib/formatDistance/index.js": [
		87139,
		7,
		87139
	],
	"./ta/_lib/formatLong": [
		16572,
		7,
		16572
	],
	"./ta/_lib/formatLong/": [
		16572,
		7,
		16572
	],
	"./ta/_lib/formatLong/index": [
		16572,
		7,
		16572
	],
	"./ta/_lib/formatLong/index.js": [
		16572,
		7,
		16572
	],
	"./ta/_lib/formatRelative": [
		76712,
		7,
		76712
	],
	"./ta/_lib/formatRelative/": [
		76712,
		7,
		76712
	],
	"./ta/_lib/formatRelative/index": [
		76712,
		7,
		76712
	],
	"./ta/_lib/formatRelative/index.js": [
		76712,
		7,
		76712
	],
	"./ta/_lib/localize": [
		97246,
		7,
		97246
	],
	"./ta/_lib/localize/": [
		97246,
		7,
		97246
	],
	"./ta/_lib/localize/index": [
		97246,
		7,
		97246
	],
	"./ta/_lib/localize/index.js": [
		97246,
		7,
		97246
	],
	"./ta/_lib/match": [
		48519,
		7,
		48519
	],
	"./ta/_lib/match/": [
		48519,
		7,
		48519
	],
	"./ta/_lib/match/index": [
		48519,
		7,
		48519
	],
	"./ta/_lib/match/index.js": [
		48519,
		7,
		48519
	],
	"./ta/index": [
		16567,
		7,
		16567
	],
	"./ta/index.d": [
		85761,
		9,
		85761
	],
	"./ta/index.d.ts": [
		85761,
		9,
		85761
	],
	"./ta/index.js": [
		16567,
		7,
		16567
	],
	"./ta/index.js.flow": [
		42222,
		7,
		42222
	],
	"./ta/package": [
		12520,
		3,
		12520
	],
	"./ta/package.json": [
		12520,
		3,
		12520
	],
	"./te": [
		11172,
		9,
		9443
	],
	"./te/": [
		11172,
		9,
		9443
	],
	"./te/_lib/formatDistance": [
		84247,
		7,
		84247
	],
	"./te/_lib/formatDistance/": [
		84247,
		7,
		84247
	],
	"./te/_lib/formatDistance/index": [
		84247,
		7,
		84247
	],
	"./te/_lib/formatDistance/index.js": [
		84247,
		7,
		84247
	],
	"./te/_lib/formatLong": [
		62759,
		7,
		62759
	],
	"./te/_lib/formatLong/": [
		62759,
		7,
		62759
	],
	"./te/_lib/formatLong/index": [
		62759,
		7,
		62759
	],
	"./te/_lib/formatLong/index.js": [
		62759,
		7,
		62759
	],
	"./te/_lib/formatRelative": [
		34023,
		7,
		66295
	],
	"./te/_lib/formatRelative/": [
		34023,
		7,
		66295
	],
	"./te/_lib/formatRelative/index": [
		34023,
		7,
		66295
	],
	"./te/_lib/formatRelative/index.js": [
		34023,
		7,
		66295
	],
	"./te/_lib/localize": [
		90491,
		7,
		90491
	],
	"./te/_lib/localize/": [
		90491,
		7,
		90491
	],
	"./te/_lib/localize/index": [
		90491,
		7,
		90491
	],
	"./te/_lib/localize/index.js": [
		90491,
		7,
		90491
	],
	"./te/_lib/match": [
		67308,
		7,
		67308
	],
	"./te/_lib/match/": [
		67308,
		7,
		67308
	],
	"./te/_lib/match/index": [
		67308,
		7,
		67308
	],
	"./te/_lib/match/index.js": [
		67308,
		7,
		67308
	],
	"./te/index": [
		42629,
		7,
		42629
	],
	"./te/index.d": [
		9443,
		9,
		9443
	],
	"./te/index.d.ts": [
		9443,
		9,
		9443
	],
	"./te/index.js": [
		42629,
		7,
		42629
	],
	"./te/index.js.flow": [
		50644,
		7,
		50644
	],
	"./te/package": [
		49083,
		3,
		49083
	],
	"./te/package.json": [
		49083,
		3,
		49083
	],
	"./th": [
		25062,
		9,
		77974
	],
	"./th/": [
		25062,
		9,
		77974
	],
	"./th/_lib/formatDistance": [
		26130,
		7,
		26130
	],
	"./th/_lib/formatDistance/": [
		26130,
		7,
		26130
	],
	"./th/_lib/formatDistance/index": [
		26130,
		7,
		26130
	],
	"./th/_lib/formatDistance/index.js": [
		26130,
		7,
		26130
	],
	"./th/_lib/formatLong": [
		3481,
		7,
		3481
	],
	"./th/_lib/formatLong/": [
		3481,
		7,
		3481
	],
	"./th/_lib/formatLong/index": [
		3481,
		7,
		3481
	],
	"./th/_lib/formatLong/index.js": [
		3481,
		7,
		3481
	],
	"./th/_lib/formatRelative": [
		48327,
		7,
		48327
	],
	"./th/_lib/formatRelative/": [
		48327,
		7,
		48327
	],
	"./th/_lib/formatRelative/index": [
		48327,
		7,
		48327
	],
	"./th/_lib/formatRelative/index.js": [
		48327,
		7,
		48327
	],
	"./th/_lib/localize": [
		30439,
		7,
		30439
	],
	"./th/_lib/localize/": [
		30439,
		7,
		30439
	],
	"./th/_lib/localize/index": [
		30439,
		7,
		30439
	],
	"./th/_lib/localize/index.js": [
		30439,
		7,
		30439
	],
	"./th/_lib/match": [
		97046,
		7,
		97046
	],
	"./th/_lib/match/": [
		97046,
		7,
		97046
	],
	"./th/_lib/match/index": [
		97046,
		7,
		97046
	],
	"./th/_lib/match/index.js": [
		97046,
		7,
		97046
	],
	"./th/index": [
		63277,
		7,
		63277
	],
	"./th/index.d": [
		77974,
		9,
		77974
	],
	"./th/index.d.ts": [
		77974,
		9,
		77974
	],
	"./th/index.js": [
		63277,
		7,
		63277
	],
	"./th/index.js.flow": [
		18011,
		7,
		18011
	],
	"./th/package": [
		32022,
		3,
		32022
	],
	"./th/package.json": [
		32022,
		3,
		32022
	],
	"./tr": [
		61573,
		9,
		66154
	],
	"./tr/": [
		61573,
		9,
		66154
	],
	"./tr/_lib/formatDistance": [
		51086,
		7,
		51086
	],
	"./tr/_lib/formatDistance/": [
		51086,
		7,
		51086
	],
	"./tr/_lib/formatDistance/index": [
		51086,
		7,
		51086
	],
	"./tr/_lib/formatDistance/index.js": [
		51086,
		7,
		51086
	],
	"./tr/_lib/formatLong": [
		73850,
		7,
		73850
	],
	"./tr/_lib/formatLong/": [
		73850,
		7,
		73850
	],
	"./tr/_lib/formatLong/index": [
		73850,
		7,
		73850
	],
	"./tr/_lib/formatLong/index.js": [
		73850,
		7,
		73850
	],
	"./tr/_lib/formatRelative": [
		83967,
		7,
		83967
	],
	"./tr/_lib/formatRelative/": [
		83967,
		7,
		83967
	],
	"./tr/_lib/formatRelative/index": [
		83967,
		7,
		83967
	],
	"./tr/_lib/formatRelative/index.js": [
		83967,
		7,
		83967
	],
	"./tr/_lib/localize": [
		7802,
		7,
		7802
	],
	"./tr/_lib/localize/": [
		7802,
		7,
		7802
	],
	"./tr/_lib/localize/index": [
		7802,
		7,
		7802
	],
	"./tr/_lib/localize/index.js": [
		7802,
		7,
		7802
	],
	"./tr/_lib/match": [
		92021,
		7,
		92021
	],
	"./tr/_lib/match/": [
		92021,
		7,
		92021
	],
	"./tr/_lib/match/index": [
		92021,
		7,
		92021
	],
	"./tr/_lib/match/index.js": [
		92021,
		7,
		92021
	],
	"./tr/index": [
		71961,
		7,
		71961
	],
	"./tr/index.d": [
		66154,
		9,
		66154
	],
	"./tr/index.d.ts": [
		66154,
		9,
		66154
	],
	"./tr/index.js": [
		71961,
		7,
		71961
	],
	"./tr/index.js.flow": [
		72559,
		7,
		72559
	],
	"./tr/package": [
		34953,
		3,
		34953
	],
	"./tr/package.json": [
		34953,
		3,
		34953
	],
	"./types": [
		28922,
		7,
		28922
	],
	"./types.js": [
		28922,
		7,
		28922
	],
	"./ug": [
		60340,
		9,
		43914
	],
	"./ug/": [
		60340,
		9,
		43914
	],
	"./ug/_lib/formatDistance": [
		4552,
		7,
		4552
	],
	"./ug/_lib/formatDistance/": [
		4552,
		7,
		4552
	],
	"./ug/_lib/formatDistance/index": [
		4552,
		7,
		4552
	],
	"./ug/_lib/formatDistance/index.js": [
		4552,
		7,
		4552
	],
	"./ug/_lib/formatLong": [
		71869,
		7,
		71869
	],
	"./ug/_lib/formatLong/": [
		71869,
		7,
		71869
	],
	"./ug/_lib/formatLong/index": [
		71869,
		7,
		71869
	],
	"./ug/_lib/formatLong/index.js": [
		71869,
		7,
		71869
	],
	"./ug/_lib/formatRelative": [
		62816,
		7,
		62816
	],
	"./ug/_lib/formatRelative/": [
		62816,
		7,
		62816
	],
	"./ug/_lib/formatRelative/index": [
		62816,
		7,
		62816
	],
	"./ug/_lib/formatRelative/index.js": [
		62816,
		7,
		62816
	],
	"./ug/_lib/localize": [
		43431,
		7,
		43431
	],
	"./ug/_lib/localize/": [
		43431,
		7,
		43431
	],
	"./ug/_lib/localize/index": [
		43431,
		7,
		43431
	],
	"./ug/_lib/localize/index.js": [
		43431,
		7,
		43431
	],
	"./ug/_lib/match": [
		9211,
		7,
		9211
	],
	"./ug/_lib/match/": [
		9211,
		7,
		9211
	],
	"./ug/_lib/match/index": [
		9211,
		7,
		9211
	],
	"./ug/_lib/match/index.js": [
		9211,
		7,
		9211
	],
	"./ug/index": [
		62796,
		7,
		62796
	],
	"./ug/index.d": [
		43914,
		9,
		43914
	],
	"./ug/index.d.ts": [
		43914,
		9,
		43914
	],
	"./ug/index.js": [
		62796,
		7,
		62796
	],
	"./ug/index.js.flow": [
		65431,
		7,
		65431
	],
	"./ug/package": [
		65078,
		3,
		65078
	],
	"./ug/package.json": [
		65078,
		3,
		65078
	],
	"./uk": [
		63111,
		9,
		60643
	],
	"./uk/": [
		63111,
		9,
		60643
	],
	"./uk/_lib/formatDistance": [
		5257,
		7,
		5257
	],
	"./uk/_lib/formatDistance/": [
		5257,
		7,
		5257
	],
	"./uk/_lib/formatDistance/index": [
		5257,
		7,
		5257
	],
	"./uk/_lib/formatDistance/index.js": [
		5257,
		7,
		5257
	],
	"./uk/_lib/formatLong": [
		57576,
		7,
		57576
	],
	"./uk/_lib/formatLong/": [
		57576,
		7,
		57576
	],
	"./uk/_lib/formatLong/index": [
		57576,
		7,
		57576
	],
	"./uk/_lib/formatLong/index.js": [
		57576,
		7,
		57576
	],
	"./uk/_lib/formatRelative": [
		83154,
		7,
		76566
	],
	"./uk/_lib/formatRelative/": [
		83154,
		7,
		76566
	],
	"./uk/_lib/formatRelative/index": [
		83154,
		7,
		76566
	],
	"./uk/_lib/formatRelative/index.js": [
		83154,
		7,
		76566
	],
	"./uk/_lib/localize": [
		31049,
		7,
		31049
	],
	"./uk/_lib/localize/": [
		31049,
		7,
		31049
	],
	"./uk/_lib/localize/index": [
		31049,
		7,
		31049
	],
	"./uk/_lib/localize/index.js": [
		31049,
		7,
		31049
	],
	"./uk/_lib/match": [
		40533,
		7,
		40533
	],
	"./uk/_lib/match/": [
		40533,
		7,
		40533
	],
	"./uk/_lib/match/index": [
		40533,
		7,
		40533
	],
	"./uk/_lib/match/index.js": [
		40533,
		7,
		40533
	],
	"./uk/index": [
		94889,
		7,
		76566
	],
	"./uk/index.d": [
		60643,
		9,
		60643
	],
	"./uk/index.d.ts": [
		60643,
		9,
		60643
	],
	"./uk/index.js": [
		94889,
		7,
		76566
	],
	"./uk/index.js.flow": [
		56433,
		7,
		56433
	],
	"./uk/package": [
		61629,
		3,
		61629
	],
	"./uk/package.json": [
		61629,
		3,
		61629
	],
	"./uz": [
		34200,
		9,
		41116
	],
	"./uz-Cyrl": [
		90337,
		9,
		45761
	],
	"./uz-Cyrl/": [
		90337,
		9,
		45761
	],
	"./uz-Cyrl/_lib/formatDistance": [
		5975,
		7,
		5975
	],
	"./uz-Cyrl/_lib/formatDistance/": [
		5975,
		7,
		5975
	],
	"./uz-Cyrl/_lib/formatDistance/index": [
		5975,
		7,
		5975
	],
	"./uz-Cyrl/_lib/formatDistance/index.js": [
		5975,
		7,
		5975
	],
	"./uz-Cyrl/_lib/formatLong": [
		98617,
		7,
		98617
	],
	"./uz-Cyrl/_lib/formatLong/": [
		98617,
		7,
		98617
	],
	"./uz-Cyrl/_lib/formatLong/index": [
		98617,
		7,
		98617
	],
	"./uz-Cyrl/_lib/formatLong/index.js": [
		98617,
		7,
		98617
	],
	"./uz-Cyrl/_lib/formatRelative": [
		8955,
		7,
		8955
	],
	"./uz-Cyrl/_lib/formatRelative/": [
		8955,
		7,
		8955
	],
	"./uz-Cyrl/_lib/formatRelative/index": [
		8955,
		7,
		8955
	],
	"./uz-Cyrl/_lib/formatRelative/index.js": [
		8955,
		7,
		8955
	],
	"./uz-Cyrl/_lib/localize": [
		64816,
		7,
		64816
	],
	"./uz-Cyrl/_lib/localize/": [
		64816,
		7,
		64816
	],
	"./uz-Cyrl/_lib/localize/index": [
		64816,
		7,
		64816
	],
	"./uz-Cyrl/_lib/localize/index.js": [
		64816,
		7,
		64816
	],
	"./uz-Cyrl/_lib/match": [
		72679,
		7,
		72679
	],
	"./uz-Cyrl/_lib/match/": [
		72679,
		7,
		72679
	],
	"./uz-Cyrl/_lib/match/index": [
		72679,
		7,
		72679
	],
	"./uz-Cyrl/_lib/match/index.js": [
		72679,
		7,
		72679
	],
	"./uz-Cyrl/index": [
		76107,
		7,
		76107
	],
	"./uz-Cyrl/index.d": [
		45761,
		9,
		45761
	],
	"./uz-Cyrl/index.d.ts": [
		45761,
		9,
		45761
	],
	"./uz-Cyrl/index.js": [
		76107,
		7,
		76107
	],
	"./uz-Cyrl/index.js.flow": [
		23155,
		7,
		23155
	],
	"./uz-Cyrl/package": [
		8939,
		3,
		8939
	],
	"./uz-Cyrl/package.json": [
		8939,
		3,
		8939
	],
	"./uz/": [
		34200,
		9,
		41116
	],
	"./uz/_lib/formatDistance": [
		85607,
		7,
		85607
	],
	"./uz/_lib/formatDistance/": [
		85607,
		7,
		85607
	],
	"./uz/_lib/formatDistance/index": [
		85607,
		7,
		85607
	],
	"./uz/_lib/formatDistance/index.js": [
		85607,
		7,
		85607
	],
	"./uz/_lib/formatLong": [
		87229,
		7,
		87229
	],
	"./uz/_lib/formatLong/": [
		87229,
		7,
		87229
	],
	"./uz/_lib/formatLong/index": [
		87229,
		7,
		87229
	],
	"./uz/_lib/formatLong/index.js": [
		87229,
		7,
		87229
	],
	"./uz/_lib/formatRelative": [
		70623,
		7,
		70623
	],
	"./uz/_lib/formatRelative/": [
		70623,
		7,
		70623
	],
	"./uz/_lib/formatRelative/index": [
		70623,
		7,
		70623
	],
	"./uz/_lib/formatRelative/index.js": [
		70623,
		7,
		70623
	],
	"./uz/_lib/localize": [
		68228,
		7,
		68228
	],
	"./uz/_lib/localize/": [
		68228,
		7,
		68228
	],
	"./uz/_lib/localize/index": [
		68228,
		7,
		68228
	],
	"./uz/_lib/localize/index.js": [
		68228,
		7,
		68228
	],
	"./uz/_lib/match": [
		93857,
		7,
		93857
	],
	"./uz/_lib/match/": [
		93857,
		7,
		93857
	],
	"./uz/_lib/match/index": [
		93857,
		7,
		93857
	],
	"./uz/_lib/match/index.js": [
		93857,
		7,
		93857
	],
	"./uz/index": [
		42198,
		7,
		42198
	],
	"./uz/index.d": [
		41116,
		9,
		41116
	],
	"./uz/index.d.ts": [
		41116,
		9,
		41116
	],
	"./uz/index.js": [
		42198,
		7,
		42198
	],
	"./uz/index.js.flow": [
		65905,
		7,
		65905
	],
	"./uz/package": [
		16840,
		3,
		16840
	],
	"./uz/package.json": [
		16840,
		3,
		16840
	],
	"./vi": [
		56409,
		9,
		75600
	],
	"./vi/": [
		56409,
		9,
		75600
	],
	"./vi/_lib/formatDistance": [
		41967,
		7,
		41967
	],
	"./vi/_lib/formatDistance/": [
		41967,
		7,
		41967
	],
	"./vi/_lib/formatDistance/index": [
		41967,
		7,
		41967
	],
	"./vi/_lib/formatDistance/index.js": [
		41967,
		7,
		41967
	],
	"./vi/_lib/formatLong": [
		61106,
		7,
		61106
	],
	"./vi/_lib/formatLong/": [
		61106,
		7,
		61106
	],
	"./vi/_lib/formatLong/index": [
		61106,
		7,
		61106
	],
	"./vi/_lib/formatLong/index.js": [
		61106,
		7,
		61106
	],
	"./vi/_lib/formatRelative": [
		66590,
		7,
		66590
	],
	"./vi/_lib/formatRelative/": [
		66590,
		7,
		66590
	],
	"./vi/_lib/formatRelative/index": [
		66590,
		7,
		66590
	],
	"./vi/_lib/formatRelative/index.js": [
		66590,
		7,
		66590
	],
	"./vi/_lib/localize": [
		50529,
		7,
		50529
	],
	"./vi/_lib/localize/": [
		50529,
		7,
		50529
	],
	"./vi/_lib/localize/index": [
		50529,
		7,
		50529
	],
	"./vi/_lib/localize/index.js": [
		50529,
		7,
		50529
	],
	"./vi/_lib/match": [
		53079,
		7,
		53079
	],
	"./vi/_lib/match/": [
		53079,
		7,
		53079
	],
	"./vi/_lib/match/index": [
		53079,
		7,
		53079
	],
	"./vi/_lib/match/index.js": [
		53079,
		7,
		53079
	],
	"./vi/index": [
		41318,
		7,
		41318
	],
	"./vi/index.d": [
		75600,
		9,
		75600
	],
	"./vi/index.d.ts": [
		75600,
		9,
		75600
	],
	"./vi/index.js": [
		41318,
		7,
		41318
	],
	"./vi/index.js.flow": [
		36625,
		7,
		36625
	],
	"./vi/package": [
		12629,
		3,
		12629
	],
	"./vi/package.json": [
		12629,
		3,
		12629
	],
	"./zh-CN": [
		80894,
		9,
		35347
	],
	"./zh-CN/": [
		80894,
		9,
		35347
	],
	"./zh-CN/_lib/formatDistance": [
		19346,
		7,
		19346
	],
	"./zh-CN/_lib/formatDistance/": [
		19346,
		7,
		19346
	],
	"./zh-CN/_lib/formatDistance/index": [
		19346,
		7,
		19346
	],
	"./zh-CN/_lib/formatDistance/index.js": [
		19346,
		7,
		19346
	],
	"./zh-CN/_lib/formatLong": [
		498,
		7,
		43640
	],
	"./zh-CN/_lib/formatLong/": [
		498,
		7,
		43640
	],
	"./zh-CN/_lib/formatLong/index": [
		498,
		7,
		43640
	],
	"./zh-CN/_lib/formatLong/index.js": [
		498,
		7,
		43640
	],
	"./zh-CN/_lib/formatRelative": [
		728,
		7,
		73464
	],
	"./zh-CN/_lib/formatRelative/": [
		728,
		7,
		73464
	],
	"./zh-CN/_lib/formatRelative/index": [
		728,
		7,
		73464
	],
	"./zh-CN/_lib/formatRelative/index.js": [
		728,
		7,
		73464
	],
	"./zh-CN/_lib/localize": [
		71089,
		7,
		71089
	],
	"./zh-CN/_lib/localize/": [
		71089,
		7,
		71089
	],
	"./zh-CN/_lib/localize/index": [
		71089,
		7,
		71089
	],
	"./zh-CN/_lib/localize/index.js": [
		71089,
		7,
		71089
	],
	"./zh-CN/_lib/match": [
		24191,
		7,
		24191
	],
	"./zh-CN/_lib/match/": [
		24191,
		7,
		24191
	],
	"./zh-CN/_lib/match/index": [
		24191,
		7,
		24191
	],
	"./zh-CN/_lib/match/index.js": [
		24191,
		7,
		24191
	],
	"./zh-CN/index": [
		5441,
		7,
		5441
	],
	"./zh-CN/index.d": [
		35347,
		9,
		35347
	],
	"./zh-CN/index.d.ts": [
		35347,
		9,
		35347
	],
	"./zh-CN/index.js": [
		5441,
		7,
		5441
	],
	"./zh-CN/index.js.flow": [
		70970,
		7,
		96169
	],
	"./zh-CN/package": [
		55739,
		3,
		55739
	],
	"./zh-CN/package.json": [
		55739,
		3,
		55739
	],
	"./zh-HK": [
		73616,
		9,
		17144
	],
	"./zh-HK/": [
		73616,
		9,
		17144
	],
	"./zh-HK/_lib/formatDistance": [
		21992,
		7,
		21992
	],
	"./zh-HK/_lib/formatDistance/": [
		21992,
		7,
		21992
	],
	"./zh-HK/_lib/formatDistance/index": [
		21992,
		7,
		21992
	],
	"./zh-HK/_lib/formatDistance/index.js": [
		21992,
		7,
		21992
	],
	"./zh-HK/_lib/formatLong": [
		49577,
		7,
		49577
	],
	"./zh-HK/_lib/formatLong/": [
		49577,
		7,
		49577
	],
	"./zh-HK/_lib/formatLong/index": [
		49577,
		7,
		49577
	],
	"./zh-HK/_lib/formatLong/index.js": [
		49577,
		7,
		49577
	],
	"./zh-HK/_lib/formatRelative": [
		87006,
		7,
		87006
	],
	"./zh-HK/_lib/formatRelative/": [
		87006,
		7,
		87006
	],
	"./zh-HK/_lib/formatRelative/index": [
		87006,
		7,
		87006
	],
	"./zh-HK/_lib/formatRelative/index.js": [
		87006,
		7,
		87006
	],
	"./zh-HK/_lib/localize": [
		61506,
		7,
		61506
	],
	"./zh-HK/_lib/localize/": [
		61506,
		7,
		61506
	],
	"./zh-HK/_lib/localize/index": [
		61506,
		7,
		61506
	],
	"./zh-HK/_lib/localize/index.js": [
		61506,
		7,
		61506
	],
	"./zh-HK/_lib/match": [
		72039,
		7,
		72039
	],
	"./zh-HK/_lib/match/": [
		72039,
		7,
		72039
	],
	"./zh-HK/_lib/match/index": [
		72039,
		7,
		72039
	],
	"./zh-HK/_lib/match/index.js": [
		72039,
		7,
		72039
	],
	"./zh-HK/index": [
		44644,
		7,
		44644
	],
	"./zh-HK/index.d": [
		17144,
		9,
		17144
	],
	"./zh-HK/index.d.ts": [
		17144,
		9,
		17144
	],
	"./zh-HK/index.js": [
		44644,
		7,
		44644
	],
	"./zh-HK/index.js.flow": [
		68697,
		7,
		68697
	],
	"./zh-HK/package": [
		86682,
		3,
		86682
	],
	"./zh-HK/package.json": [
		86682,
		3,
		86682
	],
	"./zh-TW": [
		51529,
		9,
		97583
	],
	"./zh-TW/": [
		51529,
		9,
		97583
	],
	"./zh-TW/_lib/formatDistance": [
		99049,
		7,
		99049
	],
	"./zh-TW/_lib/formatDistance/": [
		99049,
		7,
		99049
	],
	"./zh-TW/_lib/formatDistance/index": [
		99049,
		7,
		99049
	],
	"./zh-TW/_lib/formatDistance/index.js": [
		99049,
		7,
		99049
	],
	"./zh-TW/_lib/formatLong": [
		21135,
		7,
		21135
	],
	"./zh-TW/_lib/formatLong/": [
		21135,
		7,
		21135
	],
	"./zh-TW/_lib/formatLong/index": [
		21135,
		7,
		21135
	],
	"./zh-TW/_lib/formatLong/index.js": [
		21135,
		7,
		21135
	],
	"./zh-TW/_lib/formatRelative": [
		31513,
		7,
		11907
	],
	"./zh-TW/_lib/formatRelative/": [
		31513,
		7,
		11907
	],
	"./zh-TW/_lib/formatRelative/index": [
		31513,
		7,
		11907
	],
	"./zh-TW/_lib/formatRelative/index.js": [
		31513,
		7,
		11907
	],
	"./zh-TW/_lib/localize": [
		93867,
		7,
		93867
	],
	"./zh-TW/_lib/localize/": [
		93867,
		7,
		93867
	],
	"./zh-TW/_lib/localize/index": [
		93867,
		7,
		93867
	],
	"./zh-TW/_lib/localize/index.js": [
		93867,
		7,
		93867
	],
	"./zh-TW/_lib/match": [
		56980,
		7,
		56980
	],
	"./zh-TW/_lib/match/": [
		56980,
		7,
		56980
	],
	"./zh-TW/_lib/match/index": [
		56980,
		7,
		56980
	],
	"./zh-TW/_lib/match/index.js": [
		56980,
		7,
		56980
	],
	"./zh-TW/index": [
		89457,
		7,
		89457
	],
	"./zh-TW/index.d": [
		97583,
		9,
		97583
	],
	"./zh-TW/index.d.ts": [
		97583,
		9,
		97583
	],
	"./zh-TW/index.js": [
		89457,
		7,
		89457
	],
	"./zh-TW/index.js.flow": [
		89597,
		7,
		89597
	],
	"./zh-TW/package": [
		25343,
		3,
		25343
	],
	"./zh-TW/package.json": [
		25343,
		3,
		25343
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 58588;
module.exports = webpackAsyncContext;